import React, { useEffect, useState, useContext } from "react";
import { Box, Typography, Menu, MenuItem, Button } from "@mui/material";
import "../../cssfiles/homepage.css";
import LK_Add from "../../images/LK_Add";
import LK_EyeOpen from "../../images/LK_EyeOpen";
import LK_EyeClose from "../../images/LK_EyeClose";
import { ThemeContext } from "../Homepage";
import CustomButton from "../CommonComponents/CustomButton";
import CustomCancelButton from "../CommonComponents/CustomCancelButton";
import ExpandMoreOutlinedIcon from "@mui/icons-material/ExpandMoreOutlined";
import ExpandLessOutlinedIcon from "@mui/icons-material/ExpandLessOutlined";
import CustomTextField from "../CommonComponents/CustomTextField";
import CustomCheckbox from "../CommonComponents/CustomCheckbox";
import CustomDropDown from "../CommonComponents/CustomDropDown";
import CustomUploadButton from "../CommonComponents/CustomUploadButton";
import { useSelector, useDispatch } from "react-redux";
import { updategatewayno, getgatewayno } from "../../store/gateway_config_data";
import { gatewaycreate } from "../../Restclient/datacollection";
import { gatewaydelete } from "../../Restclient/datacollection";
import { getdevicelist } from "../../Restclient/datacollection";
import { getgateways } from "../../Restclient/datacollection";
import MoreVertIcon from "@mui/icons-material/MoreVert";
import Divider from "@mui/material/Divider";
import LK_Delete from "../../images/LK_Delete";
import LK_Copy from "../../images/LK_Copy";
import LK_Select from "../../images/LK_Select";
import LK_Close from "../../images/LK_Close";
import LK_Search from "../../images/LK_Search";
import Dialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import DialogTitle from "@mui/material/DialogTitle";
import DialogContent from "@mui/material/DialogContent";
import { gatewaylivedata } from "../../Restclient/datacollection";
import CustomDialogBox from "../CommonComponents/CustomDialogBox";
import LK_Refresh from "../../images/LK_Refresh";
import LK_Loading from "../../images/LK_Loading.gif";
import CustomToast from "../CommonComponents/CustomToast";
import CustomTooltip from "../CommonComponents/CustomTooltip";

export default function Gateways() {
  // var payloadStructure = {
  //     id: '1',
  //     label:'[',
  //     pagename: 'Emptyjson',
  //     children:[
  //         {
  //             id: '2',
  //             label:'{',
  //             pagename: 'Emptyjson',
  //             children:[
  //                 {
  //                     id: '20',
  //                     label:'Device',
  //                     pagename: 'Emptyjson',
  //                 }
  //             ]
  //         },
  //         {
  //             id: '3',
  //             label:'}',
  //             pagename: 'Emptyjson',
  //             children:[]
  //         }

  //     ]
  // }
  // const payloadStructure = [[  {"Device1":"","Status":0,"UID":"",timestamp:1235667,"Data":{"Tag1":"","Tag2":""}},{"Device2":"","Status":0,"UID":"",timestamp:1235667,"Data":{"Tag1":"","Tag2":""}}]];
  const payloadStructure = [
    "{gateway-UUID}",
    {
      "Device-Name": "{device name i.e like Meters name etc.}",
      Status: "{Status of device in boolean i.e 1/0 connected/disconnected}",
      "Device-UUID": "{unique ID generated by application}",
      timestamp: "{in epoch format}",
      Data: {
        "{tag-name}": "{value}",
        "{tag-name}": "{value}",
      },
    },
    {
      "Device-Name": "{device name i.e like Meters name etc.}",
      Status: "{Status of device in boolean i.e 1/0 connected/disconnected}",
      "Device-UUID": "{unique ID generated by application}",
      timestamp: "{in epoch format}",
      Data: {
        "{tag-name}": "{value}",
        "{tag-name}": "{value}",
      },
    },
  ];

  const connectionMethod = ["Simple MQTT", "Azure IOT"];
  const protocol = ["MQTT"];
  const authenticationMethod = ["Symmetric Key", "X.509"];
  const authenticationMethoddisabled = ["X.509"];
  const filter = [
    "Status Connected",
    "Status Disconnected",
    "State Enabled",
    "State Disabled",
  ];
  const filterMap = { connectionstate: "Status", enable: "State" };

  const gatewayno = useSelector((state) => state.gatewayconfigdata.gatewayno);
  const userdetails = useSelector((state) => state.logindata.userdetails);
  const projectname = useSelector(
    (state) => state.mainpagedata.selectedprojectname,
  );

  const { theme } = useContext(ThemeContext);
  const dispatch = useDispatch();
  const [openForm, setOpenForm] = React.useState(0);
  const [gatewayinfo, setGatewayInfo] = useState({
    organizationId: "",
    projectId: "",
    id: "",
    data: {
      gatewayName: "",
      serialNo: "",
      description: "",
      protocol: "",
      connectionMethod: connectionMethod[0],
      make: "",
      model: "",
      firmware: "",
      enable: true,
      connectionState: "Disconnected",
      payload: "",
      radioValue: "",
      authenticationMethod: authenticationMethod[0],
      SAS: "",
      primaryConnectionString: "",
      userName: "",
      password: "",
      serverName: "",
      topicName: "",
      rootCACert: "",
      clientId: "",
      qos: "",
      passwordExpiry: "",
      portno: "",
      keepAlive: "",
      tlsEnable: "",
      privateKey: "",
      csrGenrated: "",
      gatewaycert: "",
    },
  });
  const [required, setRequired] = React.useState(0);
  const [saveStatus, setSaveStatus] = React.useState(0);
    const [copyStatus, setCopyStatus] = React.useState(0);
  const [deleteGateway, setDeleteGateway] = React.useState(0);
  const [deleteGatewayArr, setDeleteGatewayArr] = React.useState([]);
  const [deleteConfimed, setDeleteConfirmed] = React.useState(0);
  const [deleteSuccess, setDeleteSuccess] = React.useState(0);
  const [search, setSearch] = useState({ searchText: "", filterSelected: "" });
  const [ifsearching, setifSearching] = useState(0);
  const [searchList, setsearchList] = React.useState([]);
  const [devicelist, setDevicelist] = useState([]);
  const [connState, setConnState] = useState([]);
  const [loading, setLoading] = useState(1);
  const [disableButtons, setDisableButtons] = useState(99);
  //for disableButtons = 0, all buttons are enabled
  //for disableButtons = 99, all buttons are disabled
  //for disableButtons = 1, only delete button  and select all and close is enabled  ///search  what about search while deleting??
  //for disableButtons = 2, only save form and close form is enabled ?

  useEffect(() => {
    getgateways(getgatewaycallback);
    getdevicelist(getdevicelistcallback);
    setLoading(1);
  }, []);

  useEffect(() => {
    getgateways(getgatewaycallback);
    getdevicelist(getdevicelistcallback);
    setLoading(1);
  }, [projectname]);

  // useEffect(()=>{
  // },[projectname])

  useEffect(() => {
    if (deleteGatewayArr.length !== 0) {
      setDisableButtons(1);
    } else {
      if (disableButtons !== 99) {
        setDisableButtons(0);
      }
    }
  }, [deleteGatewayArr]);

  function allgateways(res) {
    let temp = [];
    let data;
    res.map((_val, index) => {
      // let =gatewayno[event.target.id];
      // if(res[index].ConnectionMethod!=='Simple MQTT')
      // {
      //     // res[index].AuthMethod.Password=res.data.SAS;
      //     // res[index].primaryConnectionString=res.data.primaryConnectionString;
      //     //gatewayName:"",serialNo:"",description:"",protocol:"",connectionMethod:"",make:"",model:"",firmware:"",enable:true,connectionState:"Disconnected",payload:"",radioValue:"",authenticationMethod:"",SAS:"",primaryConnectionString:"",userName:"",password:"",serverName:"",topicName:"",rootCACert:"",clientId:"",qos:"",passwordExpiry:"",portno:"",keepAlive:"",tlsEnable:"",privateKey:"",csrGenrated:"",gatewaycert:""}});
      //     data={organizationId:res[index].OrgID,projectId:res[index].ProjectID,id:res[index].GatewayID,data:{gatewayName:res[index].Name, serialNo:res[index].SN,protocol:res[index].Protocol,connectionMethod:res[index].ConnectionMethod,make:res[index].Make,model:res[index].Model,firmware:res[index].Firmware,enable:res[index].Enable,payload:res[index].PayloadTypeID,authenticationMethod:res[index].AuthMethod.Name,connectionState:"",topicName:res[index].AuthMethod.Topic,primaryConnectionString:res[index].AuthMethod.ConnectionString}};
      // }
      // else{
      //     // res[index].password=res[index].AuthMethod.Password;
      //     // res[index].serverName='OpearteIOTHUB.azure-devices.net';
      //     // res[index].userName=res[index].AuthMethod.UserName;
      //     if(res[index].AuthMethod.Name!=='X.509'){
      //         data={organizationId:res[index].OrgID,projectId:res[index].ProjectID,id:res[index].GatewayID,data:{gatewayName:res[index].Name, serialNo:res[index].SN,protocol:res[index].Protocol,connectionMethod:res[index].ConnectionMethod,make:res[index].Make,model:res[index].Model,firmware:res[index].Firmware,enable:res[index].Enable,payload:res[index].PayloadTypeID,authenticationMethod:res[index].AuthMethod.Name,connectionState:"",serverName:res[index].AuthMethod.BrokerAddress,topicName:res[index].AuthMethod.Topic,userName:res[index].AuthMethod.UserName,password:res[index].AuthMethod.Password}};
      //     }
      //     else{
      //         data={organizationId:res[index].OrgID,projectId:res[index].ProjectID,id:res[index].GatewayID,data:{gatewayName:res[index].Name, serialNo:res[index].SN,protocol:res[index].Protocol,connectionMethod:res[index].ConnectionMethod,make:res[index].Make,model:res[index].Model,firmware:res[index].Firmware,enable:res[index].Enable,payload:res[index].PayloadTypeID,authenticationMethod:res[index].AuthMethod.Name,connectionState:"",serverName:res[index].AuthMethod.BrokerAddress,topicName:res[index].AuthMethod.Topic,userName:res[index].AuthMethod.UserName,password:res[index].AuthMethod.Password,rootCACert:res[index].AuthMethod.rootCACert}};
      //     }
      // }
      data = {
        organizationId: res[index].OrgID,
        projectId: res[index].ProjectID,
        id: res[index].GatewayID,
        data: {
          gatewayName: res[index].Name,
          serialNo: res[index].SN,
          description: res[index].Description,
          protocol: res[index].Protocol,
          connectionMethod: res[index].ConnectionMethod,
          make: res[index].Make,
          model: res[index].Model,
          firmware: res[index].Firmware,
          enable: res[index].Enable,
          payload: res[index].PayloadTypeID,
          authenticationMethod: res[index].AuthMethod.Name,
          connectionState: "",
          SAS: res[index].AuthMethod.Password,
          primaryConnectionString: res[index].AuthMethod.ConnectionString,
          serverName: res[index].AuthMethod.BrokerAddress,
          topicName: res[index].AuthMethod.Topic,
          userName: res[index].AuthMethod.UserName,
          password: res[index].AuthMethod.Password,
          rootCACert: res[index].AuthMethod.rootCACert,
          keepAlive: res[index].AuthMethod.KeepAiveTimeout,
          tlsEnable: res[index].AuthMethod.TLSEnable,
          passwordExpiry: res[index].AuthMethod.PasswordExpiry,
          portno: res[index].AuthMethod.Port,
          clientId: res[index].AuthMethod.ClientId,
          qos: res[index].AuthMethod.QOS,
        },
      };
      // data={organizationId:res[index].OrgID,projectId:res[index].ProjectID, id:res[index].GatewayID ,data:{gatewayName:res[index].Name, serialNo:res[index].SN, protocol:res[index].Protocol, connectionMethod:res[index].ConnectionMethod, make:res[index].Make, model:res[index].Model,firmware:res[index].Firmware,enable:res[index].Enable,payload:res[index].PayloadTypeID,authenticationMethod:res[index].AuthMethod.Name,connectionState:"",primaryConnectionString:res[index].AuthMethod.ConnectionString,userName:res[index].AuthMethod.UserName,password:res[index].AuthMethod.Password,serverName:res[index].AuthMethod.BrokerAddress,topicName:res[index].AuthMethod.Topic,rootCACert:res[index].AuthMethod.RootCACert,clientId:res[index].AuthMethod.,qos:res[index].AuthMethod.rootCACert,passwordExpiry:res[index].AuthMethod.PasswordExpiry,portno:res[index].AuthMethod.rootCACert,keepAlive:res[index].AuthMethod.rootCACert,tlsEnable:res[index].AuthMethod.rootCACert,privateKey:res[index].AuthMethod.rootCACert,csrGenrated:res[index].AuthMethod.rootCACert"",gatewaycert:res[index].AuthMethod.rootCACert""}}
      temp = [...temp, data];
    });
    return temp;
  }

  function getgatewaycallback(res) {
    const temp = allgateways(res);
    dispatch(getgatewayno(temp));
    setLoading(0);
    setDisableButtons(0);
  }

  function getdevicelistcallback(res) {
    let data = [];
    res.map((_val, index) => {
      data = [
        ...data,
        {
          gatewayId: res[index].GatewayID,
          deviceName: res[index].Name,
          deviceId: res[index].DeviceID,
          description: res[index].Description,
          serialno: res[index].SN,
          enable: res[index].Enable,
          status: res[index].Status,
          statusLastUpdated: res[index].StatusLastUpdated,
        },
      ];
    });
    setDevicelist(data);
  }

  function handleSelectedSerialno(selectedValue) {
    gatewayinfo.data.serialNo = selectedValue;
    setGatewayInfo(gatewayinfo);
  }

  function handleDescription(selectedValue) {
    gatewayinfo.data.description = selectedValue;
    setGatewayInfo(gatewayinfo);
  }

  function handleGatewayName(selectedValue) {
    gatewayinfo.data.gatewayName = selectedValue;
    setGatewayInfo(gatewayinfo);
  }

  function handleSelectedProtocol(selectedValue) {
    gatewayinfo.data.protocol = selectedValue;
    setGatewayInfo(gatewayinfo);
  }

  function handleSelectedConnectionMethod(selectedValue) {
    gatewayinfo.data.connectionMethod = selectedValue;
    setGatewayInfo(gatewayinfo);
  }

  function handleGatewayMake(selectedValue) {
    gatewayinfo.data.make = selectedValue;
    setGatewayInfo(gatewayinfo);
  }

  function handleGatewayModel(selectedValue) {
    gatewayinfo.data.model = selectedValue;
    setGatewayInfo(gatewayinfo);
  }

  function handleGatewayFirmware(selectedValue) {
    gatewayinfo.data.firmware = selectedValue;
    setGatewayInfo(gatewayinfo);
  }

  function handleGatewayEnable(selectedValue) {
    gatewayinfo.data.enable = selectedValue;
    setGatewayInfo(gatewayinfo);
  }

  function handleSelectedMethod(selectedValue) {
    gatewayinfo.data.authenticationMethod = selectedValue;
    setGatewayInfo(gatewayinfo);
  }

  const handleCopyData = (event) => {
    navigator.clipboard.writeText(event.currentTarget.value);
        setCopyStatus(1);
  };

  const handleSaveAddForm = () => {
    if (
      gatewayinfo.data.serialNo !== "" &&
      gatewayinfo.data.gatewayName !== "" &&
      gatewayinfo.data.make !== "" &&
      gatewayinfo.data.model !==
        "" /*&& gatewayinfo.data.connectionMethod!=="" && gatewayinfo.data.authenticationMethod!==""*/
    ) {
      setRequired(0);
      if (
        gatewayno.filter(
          (val, _index) =>
            val.data.gatewayName === gatewayinfo.data.gatewayName,
        )?.length === 0 ||
        gatewayinfo.id !== ""
      ) {
        gatewayinfo.organizationId = userdetails.Organizationid;
        gatewayinfo.projectId = projectname;
        if (gatewayinfo.data.authenticationMethod === "") {
          gatewayinfo.data.authenticationMethod = authenticationMethod[0];
        }
        if (gatewayinfo.data.connectionMethod === "") {
          gatewayinfo.data.connectionMethod = connectionMethod[0];
        }
        if (gatewayinfo.data.connectionState === "") {
          gatewayinfo.data.connectionState = gatewayinfo.data.enable; /////?????????????
        }
        gatewaycreate(gatewayinfo, callback);
        setLoading(1);
        setDisableButtons(99);
      } else {
        setRequired(2);
      }
    } else {
      setOpenForm(1);
      setRequired(1);
    }
  };

  function callback(res) {
    if (res.status === 201) {
      let data = {};
      if (gatewayinfo.id === "") {
        gatewayinfo.id = res.data.deviceId;
        gatewayinfo.data.topicName = res.data.topic;
        gatewayinfo.data.password = res.data.password;
        gatewayinfo.data.serverName = res.data.brokerAddress;
        gatewayinfo.data.userName = res.data.userName;
        gatewayinfo.data.SAS = res.data.SAS;
        gatewayinfo.data.primaryConnectionString =
          res.data.primaryConnectionString;
        gatewayinfo.data.portno = res.data.portno;
        gatewayinfo.data.clientId = res.data.deviceId;
        gatewayinfo.data.qos = res.data.Qos;
        gatewayinfo.data.tlsEnable = res.data.tls;
        gatewayinfo.data.passwordExpiry = res.data.expiry;
        data = {
          organizationId: gatewayinfo.organizationId,
          projectId: gatewayinfo.projectId,
          id: gatewayinfo.id,
          data: {
            gatewayName: gatewayinfo.data.gatewayName,
            serialNo: gatewayinfo.data.serialNo,
            description: gatewayinfo.data.description,
            protocol: gatewayinfo.data.protocol,
            connectionMethod: gatewayinfo.data.connectionMethod,
            make: gatewayinfo.data.make,
            model: gatewayinfo.data.model,
            firmware: gatewayinfo.data.firmware,
            enable: gatewayinfo.data.enable,
            connectionState: gatewayinfo.data.connectionState,
            payload: gatewayinfo.data.payload,
            authenticationMethod: gatewayinfo.data.authenticationMethod,
            serverName: gatewayinfo.data.serverName,
            topicName: gatewayinfo.data.topicName,
            userName: gatewayinfo.data.userName,
            password: gatewayinfo.data.password,
            rootCACert: gatewayinfo.data.rootCACert,
            SAS: gatewayinfo.data.SAS,
            primaryConnectionString: gatewayinfo.data.primaryConnectionString,
            qos: gatewayinfo.data.qos,
            clientId: gatewayinfo.data.clientId,
            passwordExpiry: gatewayinfo.data.passwordExpiry,
            portno: gatewayinfo.data.portno,
            keepAlive: gatewayinfo.data.keepAlive,
            tlsEnable: gatewayinfo.data.tlsEnable,
            privateKey: gatewayinfo.data.privateKey,
            csrGenrated: gatewayinfo.data.csrGenrated,
            gatewaycert: gatewayinfo.data.gatewaycert,
          },
        };
        dispatch(updategatewayno(data));
      } else {
        //need to work here
        // index=gatewayno.length-1;
        // if(gatewayinfo.data.connectionMethod!==""){gatewaynores.data.data.connectionMethod=gatewayinfo.data.connectionMethod}
        // if(gatewayinfo.data.firmware!==""){gatewayno[index].data.firmware=gatewayinfo.data.firmware}
        // if(gatewayinfo.data.make!==""){gatewayno[index].data.make=gatewayinfo.data.make}
        // if(gatewayinfo.data.enable!==""){gatewayno[index].data.enable=gatewayinfo.data.enable}
        // if(gatewayinfo.data.connectionState!==""){gatewayno[index].data.connectionState=gatewayinfo.data.connectionState}
        // data={organizationId:gatewayinfo.organizationId,projectId:gatewayinfo.projectId,id:gatewayinfo.id,data:{...gatewayinfo.data}};
        const gno = [...gatewayno];
        gno.map((val, index) => {
          if (val.id === gatewayinfo.id) {
            gno[index] = {
              organizationId: gatewayinfo.organizationId,
              projectId: gatewayinfo.projectId,
              id: gatewayinfo.id,
              data: {
                gatewayName: gatewayinfo.data.gatewayName,
                serialNo: gatewayinfo.data.serialNo,
                description: gatewayinfo.data.description,
                protocol: gatewayinfo.data.protocol,
                connectionMethod: gatewayinfo.data.connectionMethod,
                make: gatewayinfo.data.make,
                model: gatewayinfo.data.model,
                firmware: gatewayinfo.data.firmware,
                enable: gatewayinfo.data.enable,
                connectionState: gatewayinfo.data.connectionState,
                payload: gatewayinfo.data.payload,
                authenticationMethod: gatewayinfo.data.authenticationMethod,
                serverName: gatewayinfo.data.serverName,
                topicName: gatewayinfo.data.topicName,
                userName: gatewayinfo.data.userName,
                password: gatewayinfo.data.password,
                rootCACert: gatewayinfo.data.rootCACert,
                SAS: gatewayinfo.data.SAS,
                primaryConnectionString:
                  gatewayinfo.data.primaryConnectionString,
                qos: gatewayinfo.data.qos,
                clientId: gatewayinfo.data.clientId,
                passwordExpiry: gatewayinfo.data.passwordExpiry,
                portno: gatewayinfo.data.portno,
                keepAlive: gatewayinfo.data.keepAlive,
                tlsEnable: gatewayinfo.data.tlsEnable,
                privateKey: gatewayinfo.data.privateKey,
                csrGenrated: gatewayinfo.data.csrGenrated,
                gatewaycert: gatewayinfo.data.gatewaycert,
              },
            };
          }
        });
        dispatch(getgatewayno(gno));
      }
      setSaveStatus(1);
    } else {
      setSaveStatus(2);
    }
    setLoading(0);
    setDisableButtons(0);
  }

  const handleCloseAddForm = () => {
    setOpenForm(0);
    setRequired(0);
    setGatewayInfo({
      organizationId: "",
      projectId: "",
      id: "",
      data: {
        gatewayName: "",
        serialNo: "",
        description: "",
        protocol: "",
        connectionMethod: connectionMethod[0],
        make: "",
        model: "",
        firmware: "",
        enable: true,
        connectionState: "Disconnected",
        payload: "",
        radioValue: "",
        authenticationMethod: authenticationMethod[0],
        SAS: "",
        primaryConnectionString: "",
        userName: "",
        password: "",
        serverName: "",
        topicName: "",
        rootCACert: "",
        clientId: "",
        qos: "",
        passwordExpiry: "",
        portno: "",
        keepAlive: "",
        tlsEnable: "",
        privateKey: "",
        csrGenrated: "",
        gatewaycert: "",
      },
    });
  };

  function handleDeleteSelected() {
    if (deleteGatewayArr.length === 0) {
      setDeleteConfirmed(2);
    } else {
      setDeleteConfirmed(1);
    }
  }

  function handleSelectAllGateways() {
    let ids = [];
    if (ifsearching !== 1) {
      //clear selected all
      if (gatewayno.length === deleteGatewayArr.length) {
        setDeleteGatewayArr(ids);
      } else {
        //selects all
        gatewayno.map((val, _index) => (ids = [...ids, val.id]));
        setDeleteGatewayArr(ids);
      }
    } else {
      //in case of searched list
      ids = [...deleteGatewayArr];
      //clear selected all
      let searchlistlen = [];
      searchList.map((val) =>
        deleteGatewayArr.map((value) => {
          if (value === val.id) {
            searchlistlen = [...searchlistlen, val.id];
          }
        }),
      );
      if (searchlistlen.length === searchList.length) {
        searchlistlen.map((value) => {
          ids = ids.filter((val) => value !== val);
        });
        setDeleteGatewayArr(ids);
      } else {
        //selects all
        searchList.map((val, _index) => {
          const ifpresent = ids.filter((value) => value === val.id);
          if (ifpresent.length === 0) {
            ids = [...ids, val.id];
          }
        });
        setDeleteGatewayArr(ids);
      }
    }
  }

  function handleDeleteConfirmed() {
    if (deleteGatewayArr.length > 0) {
      gatewaydelete(deleteGatewayArr, deletioncallback);
      setDeleteConfirmed(0);
      setLoading(1);
    } else {
      //popup plz select device
    }
  }

    function handleDeleteCancel(){
        const len =deleteGatewayArr.length;
        setDeleteGatewayArr([]);
        setDeleteGateway(0);
        if(len>0){
            setDeleteConfirmed(0);   
        }else{
            setDeleteConfirmed(3);
        }
    }

  function deletioncallback(res, _id) {
    if (res.status === 200) {
      const temp = allgateways(res.data.gateways);
      dispatch(getgatewayno(temp));
      setDeleteGatewayArr([]);
      setDeleteGateway(0);
      setDeleteSuccess(1);
      setLoading(0);
    } else {
      setDeleteSuccess(2);
      setLoading(0);
    }
  }

  function handleFilterSelected(selectedValue) {
    search.filterSelected = selectedValue;
    setSearch(search);
  }

  function handleSearchText(selectedValue) {
    search.searchText = selectedValue;
    setSearch(search);
  }

  function handleSearchCancel() {
    setSearch({ searchText: "", filterSelected: "" });
    setsearchList([]);
    setifSearching(0);
  }

  function handleSearchClick() {
    let temp = [];
    let templist = [...gatewayno];
    if (search.filterSelected !== "") {
      const filterVal = Object.entries(filterMap).find(([_key, value]) =>
        search.filterSelected.includes(value),
      );
      setifSearching(1);
      let val = "";
      if (search.filterSelected.includes("Enabled")) {
        val = true;
      } else if (search.filterSelected.includes("Disabled")) {
        val = false;
      }
      gatewayno.filter((value) => {
        if (
          search.filterSelected.includes("Connected") ||
          search.filterSelected.includes("Disconnected")
        ) {
          connState.map((val) => {
            if (val[0] === value.id && search.filterSelected.includes(val[1])) {
              temp = [...temp, value];
            }
          });
        } else {
          Object.keys(value.data).forEach((key) => {
            if (key === filterVal[0]) {
              if (
                value.data[key] === val ||
                value.data[key] === val.toString()
              ) {
                temp = [...temp, value];
              }
            }
          });
        }
        templist = [...temp];
      });
    }
    if (search.searchText !== "") {
      setifSearching(1);
      temp = [];
      templist.filter((value) => {
        if (
          value.id.toLowerCase().includes(search.searchText.toLowerCase()) ||
          value.data.gatewayName
            .toLowerCase()
            .includes(search.searchText.toLowerCase()) ||
          value.data.serialNo
            .toLowerCase()
            .includes(search.searchText.toLowerCase()) ||
          value.data.description
            .toLowerCase()
            .includes(search.searchText.toLowerCase()) ||
          value.data.protocol
            .toLowerCase()
            .includes(search.searchText.toLowerCase()) ||
          value.data.connectionMethod
            .toLowerCase()
            .includes(search.searchText.toLowerCase()) ||
          value.data.payload
            .toLowerCase()
            .includes(search.searchText.toLowerCase()) ||
          value.data.make
            .toLowerCase()
            .includes(search.searchText.toLowerCase()) ||
          value.data.model
            .toLowerCase()
            .includes(search.searchText.toLowerCase()) ||
          value.data.firmware
            .toLowerCase()
            .includes(search.searchText.toLowerCase()) ||
          value.data.authenticationMethod
            .toLowerCase()
            .includes(
              search.searchText.toLowerCase(),
            ) /*|| value.data.topicName.includes(search.searchText)*/
        ) {
          temp = [...temp, value];
        }
      });
    }
    setsearchList(temp);
  }

  function handleClone(event) {
    const temp = gatewayno[event.target.id];
    const data = {
      organizationId: temp.organizationId,
      projectId: temp.projectId,
      id: "",
      data: {
        gatewayName: temp.data.gatewayName,
        serialNo: temp.data.serialNo,
        description: temp.data.description,
        protocol: temp.data.protocol,
        connectionMethod: temp.data.connectionMethod,
        make: temp.data.make,
        model: temp.data.model,
        firmware: temp.data.firmware,
        enable: temp.data.enable,
        connectionState: temp.data.connectionState,
        payload: temp.data.payload,
        authenticationMethod: temp.data.authenticationMethod,
        serverName: temp.data.serverName,
        port: "",
        keepAlive: "",
        QOS: "",
        topicName: "",
        primaryConnectionString: "",
        userName: "",
        password: "",
        rootCACert: "",
        passwordExpiry: "",
        tlsEnable: "",
        privateKey: "",
        csrGenrated: "",
        gatewaycert: "",
      },
    };
    data.data.gatewayName = data.data.gatewayName + "_clone";
    setGatewayInfo(data);
    setOpenForm(true);
  }

  function handleRefresh() {
    getgateways(getgatewaycallback);
    getdevicelist(getdevicelistcallback);
    setLoading(1);
    setDisableButtons(99);
  }

  function handleConnectionStatus(id) {
    let status = false;
    connState.map((val) => {
      if (val[0] === id && val[1] === "Connected") {
        status = true;
      }
    });
    return status;
  }

    const convertToIST= epochts =>{
        const date= new Date(epochts*1000)
        return date.toLocaleDateString("en-IN",{timeZone:"Asia/Kolkata",hour12:false,day: "numeric", month: "numeric", year: "numeric",hour: "numeric",minute: "numeric",second: "numeric"}).replace(/,/g, "  ");;
      }


    function  handleToastClose(){
        setSaveStatus(0)
    }

    function  handleDeleteToastClose(){
        setDeleteSuccess(0)
    }
    
    const GatewayForm = props => {
        const [gatewayDetails,setGatewayDetails]=React.useState(1);
        const [protocolDetails,setProtocolDetails]=React.useState(1);
        const [payloadDetails,setPayloadDetails]=React.useState(0); 
        const [connectionDetails,setconnectionDetails]=React.useState(1);
        const [connectionMethodProp, setConnectionMethodProp] = React.useState(props.gatewayData.data.connectionMethod);
        const [authenticationMethodProp, setAuthenticationMethod] = React.useState(props.gatewayData.data.authenticationMethod);
        const [unhidepassword, setUnhidePassword] = React.useState(0);

        function handleSelectedConnectionMethodF(selectedValue){
            setConnectionMethodProp(selectedValue);
            handleSelectedConnectionMethod(selectedValue);
        };

    function handleSelectedMethodF(selectedValue) {
      setAuthenticationMethod(selectedValue);
      handleSelectedMethod(selectedValue);
      if (selectedValue === "X.509") {
        handleSelectedConnectionMethodF(connectionMethod[0]);
      } else {
        handleSelectedConnectionMethodF(connectionMethod[1]);
      }
    }

    return (
      <Box sx={{ width: "100%", height: "100%" }}>
        <Box
          sx={{
            width: "100%",
            height: "7%",
            display: "flex",
            flexDirection: "row",
            alignItems: "center",
            gap: "8px",
          }}
        >
          <Typography
            style={{ fontSize: "24px", fontWeight: 700, color: "#008CD7" }}
          >
            {props.gatewayData.id !== ""
              ? props.gatewayData.data.gatewayName
              : "Gateways"}
          </Typography>
          <Box sx={{ flexGrow: 1 }}></Box>
          {/* {required===1?<><Typography sx={{color:"#DC272D"}}>required fields to must be filled</Typography></>:<></>}
                    {saveStatus!==0?
                        <>
                            <Typography sx={{color: saveStatus===1? theme==='dark'?'#C1C1C1':'#3C3C3C':"#DC272D"}}>{saveStatus===1?"Saved Successfully!":"Save Failed"}</Typography>
                        </>
                        :
                        <></>
                    }
                    <CustomCancelButton onClick={props.closeForm} children={'Cancel'}></CustomCancelButton>
                    {/* <Button id={props.index} onClick={props.saveForm}>Save</Button> *}
                    <CustomButton id={props.index} onClick={props.saveForm} children={'Save'} width={'12px'} /> */}
                </Box>
                <Box sx={{width:'100%',height:'93%',overflow:'auto'}}>
                    <Typography className="config-heading" style={{ fontSize: '20px', fontWeight: 400, color: "#008CD7",padding:"4px",marginTop:"20px" ,/*backgroundColor:theme==='dark'?'#3C3C3C40':'#FFFFFF80'*/}}>Gateway Details <Button onClick={()=>{(gatewayDetails===1)?setGatewayDetails(0):setGatewayDetails(1)}}>{(gatewayDetails===1)?<ExpandLessOutlinedIcon style={{width: '28px', height: '28px',fontWeight: 700, color: "#008CD7",}} /> : <ExpandMoreOutlinedIcon style={{width: '28px', height: '28px',fontWeight: 700, color: "#008CD7",}}/>}</Button></Typography>
                    {gatewayDetails===1?
                        <Box  style={{overflow:"auto"}} sx={{display:"flex",gap:'0px',flexWrap:'wrap',padding:"4px 4px 12px 4px",backgroundColor:theme==='dark'?'#3C3C3C40':'#FFFFFF80'}}>
                            <Box className="config-form-box" sx={{padding:"4px 4px 4px 0px",width:"33.33%",boxSizing:'border-box',marginTop:"12px"}} >
                                <Typography  style={{ fontSize: '16px', fontWeight: 400, color: theme==='dark'?'#C1C1C1':'#3C3C3C' ,width:"224px"}}>Gateway Name <span style={{ color: "red", marginLeft: "5px" }}>*</span></Typography>
                                <CustomTextField id={'negative-feedback'} onChange={handleGatewayName} disabled={props.gatewayData.id!==""?true:false} defaultValue={props.gatewayData.id!==""?(props.gatewayData.data.gatewayName):gatewayinfo.data.gatewayName} maxLength={250} width={224} permittedCharacters={'^[a-zA-Z][a-zA-Z0-9_]*$'} errorText={"Only alphanumeric characters are allowed"}/> 
                            </Box>
                            <Box className="config-form-box" sx={{padding:"4px 4px 4px 0px",width:"33.33%",boxSizing:'border-box',marginTop:"12px"}}>
                                <Typography  style={{ fontSize: '16px', fontWeight: 400, color: theme==='dark'?'#C1C1C1':'#3C3C3C' ,width:"224px"}}>Gateway Serial No.<span style={{ color: "red", marginLeft: "5px" }}>*</span></Typography>
                                <CustomTextField id={'negative-feedback'} onChange={handleSelectedSerialno} /*disabled={props.gatewayData.id!==""?true:false}*/ defaultValue={props.gatewayData.id!==""?props.gatewayData.data.serialNo:gatewayinfo.data.serialNo} maxLength={32} width={224} permittedCharacters={'^[a-zA-Z0-9][a-zA-Z0-9_]*$'} errorText={"Only alphanumeric characters are allowed"}/> 
                            </Box>
                            {props.gatewayData.id!=="" ?
                                <Box className="config-form-box" sx={{padding:"4px 4px 4px 0px",width:"33.33%",boxSizing:'border-box',marginTop:"12px"}}>
                                    <Typography  style={{ fontSize: '16px', fontWeight: 400, color: theme==='dark'?'#C1C1C1':'#3C3C3C' ,width:"224px"}}>Gateway ID</Typography>
                                    {/* {props.gatewayData.id!==""? */}
                                        <>
                                            <Typography  style={{ fontSize: '16px', fontWeight: 400, color: theme==='dark'?'#C1C1C1':'#3C3C3C' ,/*width:"192px",*/}}>{props.gatewayData.id}</Typography>
                                            <CustomTooltip title={'Copy'} offset={[30,-20]} placement={'right-end'}>
                                                <Button onClick={handleCopyData} value={props.gatewayData.id} style={{ fontSize: '12px',height:'32px',padding:"0px", width:"32px",minWidth:"30px", fontWeight: 400, color: '#7E7E7E', alignSelf:"center",marginLeft:"0px",marginRight:"auto",marginTop:"-4px"}}><LK_Copy color='var(--GreyBaseColor)' width={"20px"} height={"20px"}/></Button>
                                            </CustomTooltip></>
                                        {/* :
                                        <>
                                        </>
                                    } */}
                                </Box>
                                :
                                <></>
                            }           
                            <Box className="config-form-box" sx={{padding:"4px 4px 4px 0px",width:"100%",boxSizing:'border-box',marginTop:"12px"}}>
                                <Typography  style={{ fontSize: '16px', fontWeight: 400, color: theme==='dark'?'#C1C1C1':'#3C3C3C' ,width:"224px"}}>Gateway Description</Typography>
                                <CustomTextField id={'negative-feedback'} onChange={handleDescription} /*disabled={props.gatewayData.id!==""?true:false}*/ defaultValue={props.gatewayData.id!==""?props.gatewayData.data.description:gatewayinfo.data.description} maxLength={250} width={1297}/> 
                            </Box>
                            <Box className="config-form-box" sx={{padding:"4px 4px 4px 0px",width:"33.33%",boxSizing:'border-box',marginTop:"12px"}}>
                                <Typography  style={{ fontSize: '16px', fontWeight: 400, color: theme==='dark'?'#C1C1C1':'#3C3C3C' ,width:"224px"}}>Gateway Make<span style={{ color: "red", marginLeft: "5px" }}>*</span></Typography>
                                <CustomTextField id={'negative-feedback'} onChange={handleGatewayMake} defaultValue={props.gatewayData.data.make} maxLength={250} width={224} permittedCharacters={'^[a-zA-Z0-9][a-zA-Z0-9_]*$'} errorText={"Only alphanumeric characters are allowed"}/> 
                            </Box>
                            <Box className="config-form-box" sx={{padding:"4px 4px 4px 0px",width:"33.33%",boxSizing:'border-box',marginTop:"12px"}}>
                                <Typography  style={{ fontSize: '16px', fontWeight: 400, color: theme==='dark'?'#C1C1C1':'#3C3C3C' ,width:"224px"}}>Gateway Model<span style={{ color: "red", marginLeft: "5px" }}>*</span></Typography>
                                <CustomTextField id={'negative-feedback'} onChange={handleGatewayModel} defaultValue={props.gatewayData.id!==""?props.gatewayData.data.model:gatewayinfo.data.model} maxLength={250} width={224} permittedCharacters={'^[a-zA-Z0-9][a-zA-Z0-9_]*$'} errorText={"Only alphanumeric characters are allowed"}/> 
                            </Box>
                            <Box className="config-form-box" sx={{padding:"4px 4px 4px 0px",width:"33.33%",boxSizing:'border-box',marginTop:"12px"}} >
                                <Typography  style={{ fontSize: '16px', fontWeight: 400, color: theme==='dark'?'#C1C1C1':'#3C3C3C',width:"224px" }}>Gateway Firmware</Typography>
                                <CustomTextField id={'negative-feedback'} defaultValue={props.gatewayData.id!==""?props.gatewayData.data.firmware:gatewayinfo.data.firmware} maxLength={250} onChange={handleGatewayFirmware} width={224} permittedCharacters={'^[a-zA-Z0-9][a-zA-Z0-9_.]*$'} errorText={"Only alphanumeric characters are allowed"}/> 
                            </Box>   
                        </Box>
                        :
                        <></>
                    }
                    <Typography className="config-heading" style={{ fontSize: '20px', fontWeight: 400, color: "#008CD7",padding:"4px",marginTop:"20px" }}>Protocol Details<Button onClick={()=>{(protocolDetails===1)?setProtocolDetails(0):setProtocolDetails(1)}}>{(protocolDetails===1)?<ExpandLessOutlinedIcon style={{width: '28px', height: '28px',fontWeight: 700, color: "#008CD7",}} /> : <ExpandMoreOutlinedIcon style={{width: '28px', height: '28px',fontWeight: 700, color: "#008CD7",}}/>}</Button></Typography>
                    {protocolDetails===1?
                        <Box  style={{overflow:"auto"}} sx={{display:"flex",gap:'0px',flexWrap:'wrap',padding:"4px 4px 12px 4px",backgroundColor:theme==='dark'?'#3C3C3C40':'#FFFFFF80'}}>
                            <Box className="config-form-box" sx={{padding:"4px 4px 4px 0px",width:"33.33%",boxSizing:'border-box',marginTop:"12px"}} >
                                <Typography  style={{ fontSize: '16px', fontWeight: 400, color: theme==='dark'?'#C1C1C1':'#3C3C3C' ,width:"224px"}}>Protocol{/*<span style={{ color: "red", marginLeft: "5px" }}>*</span>*/}</Typography>
                                <CustomDropDown options={protocol} onChange={handleSelectedProtocol} disabled={true} defaultValue={protocol[0]}></CustomDropDown> {/*defaultValue={props.gatewayData.id!==""?protocol[0]/props.gatewayData.data.protocol/:protocol[0]} */}
                            </Box>
                            <Box className="config-form-box" sx={{padding:"4px 4px 4px 0px",width:"33.33%",boxSizing:'border-box',marginTop:"12px"}}>
                                <Typography  style={{ fontSize: '16px', fontWeight: 400, color: theme==='dark'?'#C1C1C1':'#3C3C3C' ,width:"224px"}}>Authentication method{/*<span style={{ color: "red", marginLeft: "5px" }}>*</span>*/}</Typography>
                                <CustomDropDown options={authenticationMethod} disabled={props.gatewayData.id!==""?true:false} defaultValue={props.gatewayData.id!=="" || authenticationMethodProp!==""?props.gatewayData.data.authenticationMethod:authenticationMethod[0]} onChange={handleSelectedMethodF} disabledOptions={authenticationMethoddisabled}></CustomDropDown>
                            </Box>
                            <Box className="config-form-box" sx={{padding:"4px 4px 4px 0px",width:"33.33%",boxSizing:'border-box',marginTop:"12px"}} >
                                <Typography  style={{ fontSize: '16px', fontWeight: 400, color: theme==='dark'?'#C1C1C1':'#3C3C3C' ,width:"224px"}}>Connection method{/*<span style={{ color: "red", marginLeft: "5px" }}>*</span>*/}</Typography>
                                <CustomDropDown options={connectionMethod} onChange={handleSelectedConnectionMethodF} /*disabled={props.gatewayData.id!=="" ?true:false}*/ defaultValue={props.gatewayData.id!=="" || props.gatewayData.data.gatewayName.includes('_clone')?props.gatewayData.data.connectionMethod:connectionMethod[0]}></CustomDropDown>
                            </Box>
                            {props.gatewayData.id!=="" ?
                                (connectionMethodProp!=='Simple MQTT' || props.gatewayData.data.connectionMethod!=='Simple MQTT')?
                                    <>
                                        <Box className="config-form-box" sx={{padding:"4px 4px 4px 0px",width:"100%",boxSizing:'border-box',marginTop:"12px",}} >
                                            <Typography  style={{ fontSize: '16px', fontWeight: 400, color: theme==='dark'?'#C1C1C1':'#3C3C3C',width:"224px" }}>Topic</Typography>
                                            {props.gatewayData.id!==""?
                                                <>
                                                    <Box className="config-form-box"style={{gap:0 ,marginTop:0,width:'calc(100% - 354px)',overflowWrap:"break-word"}} >
                                                        <Typography  style={{ fontSize: '14px', fontWeight: 400, color: theme==='dark'?'#C1C1C1':'#3C3C3C',overflow:"hidden" }}>{props.gatewayData.data.topicName}</Typography>
                                                    </Box>
                                                    {/* <Button onClick={handleCopyData} value={props.gatewayData.data.SAS} style={{ fontSize: '12px',height:'32px',padding:"0px", width:"32px", fontWeight: 400, color: '#7E7E7E', alignSelf:"center",marginLeft:"auto",marginRight:"auto"}}><ContentCopyIcon sx={{height:"24px",width:"24px"}}/></Button> */}
                                                    <CustomTooltip title={'Copy'} offset={[30,-20]} placement={'right-end'}>
                                                        <Button onClick={handleCopyData} value={props.gatewayData.data.topicName} style={{ fontSize: '12px',height:'32px',padding:"0px", width:"32px", fontWeight: 400, color: '#7E7E7E', alignSelf:"center",marginLeft:"0px",marginRight:"auto",marginTop:"-4px"}}><LK_Copy color='var(--GreyBaseColor)' width={"20px"} height={"20px"}/></Button>
                                                    </CustomTooltip></>
                                                :
                                                <></>
                                            }
                                        </Box>
                                        <Box className="config-form-box" sx={{padding:"4px 4px 4px 0px",width:"100%",boxSizing:'border-box',marginTop:"12px",}} >
                                            <Typography  style={{ fontSize: '16px', fontWeight: 400, color: theme==='dark'?'#C1C1C1':'#3C3C3C',width:"224px" }}>Primary Connection String</Typography>
                                            {props.gatewayData.id!==""?
                                                <>
                                                    <Box className="config-form-box" style={{gap:0 ,marginTop:0,width:'calc(100% - 354px)' ,overflowWrap:"break-word",alignSelf:"center"}} >
                                                        <Typography  style={{ fontSize: '14px', fontWeight: 400, color: theme==='dark'?'#C1C1C1':'#3C3C3C',overflow:"hidden"}}>{props.gatewayData.data.primaryConnectionString}</Typography>
                                                    </Box>
                                                    <CustomTooltip title={'Copy'} offset={[30,-20]} placement={'right-end'}>
                                                        <Button onClick={handleCopyData} value={props.gatewayData.data.primaryConnectionString} style={{ fontSize: '12px',height:'32px',padding:"0px", width:"32px", fontWeight: 400, color: '#7E7E7E', alignSelf:"center",marginLeft:"0px",marginRight:"auto",marginTop:"-4px"}}><LK_Copy color='var(--GreyBaseColor)' width={"24px"} height={"24px"}/></Button>
                                                    </CustomTooltip>
                                                    {/* <Button onClick={handleCopyData} value={props.gatewayData.data.primaryConnectionString} style={{ fontSize: '12px',height:'32px',padding:"0px", width:"32px", fontWeight: 400, color: '#7E7E7E',alignSelf:"center",marginLeft:"auto",marginRight:"auto"}}><ContentCopyIcon sx={{height:"24px",width:"24px"}}/></Button> */}
                                                </>
                                                :
                                                <></>
                                            }
                                        </Box>
                                    </>
                                    :
                                    <>
                                        <Box className="config-form-box" sx={{padding:"4px 4px 4px 0px",width:"33.33%",boxSizing:'border-box',marginTop:"12px",}}>
                                            <Typography  style={{ fontSize: '16px', fontWeight: 400, color: theme==='dark'?'#C1C1C1':'#3C3C3C',width:"224px" }}>ClientId</Typography>
                                            {props.gatewayData.id!==""?
                                                <>
                                                    <Box className="config-form-box"style={{gap:0 ,marginTop:0,width:'calc(100% - 354px)',overflowWrap:"break-word"}} >
                                                        <Typography  style={{ fontSize: '14px', fontWeight: 400, color: theme==='dark'?'#C1C1C1':'#3C3C3C',overflow:"hidden" }}>{props.gatewayData.data.clientId}</Typography>
                                                    </Box>
                                                    <CustomTooltip title={'Copy'} offset={[30,-20]} placement={'right-end'}>
                                                        <Button onClick={handleCopyData} value={props.gatewayData.data.clientId} style={{ fontSize: '12px',height:'32px',padding:"0px", width:"32px", fontWeight: 400, color: '#7E7E7E', alignSelf:"center",marginLeft:"0px",marginRight:"auto",marginTop:"-4px"}}><LK_Copy color='var(--GreyBaseColor)' width={"24px"} height={"24px"}/></Button>
                                                    </CustomTooltip>
                                                    {/* <Button onClick={handleCopyData} value={props.gatewayData.data.SAS} style={{ fontSize: '12px',height:'32px',padding:"0px", width:"32px", fontWeight: 400, color: '#7E7E7E', alignSelf:"center",marginLeft:"auto",marginRight:"auto"}}><ContentCopyIcon sx={{height:"24px",width:"24px"}}/></Button> */}
                                                </>
                                                :
                                                <></>
                                            }
                                        </Box>
                                        <Box sx={{display:'flex',width:"50%",flexGrow:1}}/>
                                        <Box className="config-form-box" sx={{padding:"4px 4px 4px 0px",width:"66.67%",boxSizing:'border-box',marginTop:"12px",}}>
                                            <Typography  style={{ fontSize: '16px', fontWeight: 400, color: theme==='dark'?'#C1C1C1':'#3C3C3C',width:"224px" }}>Host Name</Typography>
                                            {props.gatewayData.id!==""?
                                                <>
                                                    <Box className="config-form-box"style={{gap:0 ,marginTop:0,width:'calc(100% - 354px)',overflowWrap:"break-word"}} >
                                                        <Typography  style={{ fontSize: '14px', fontWeight: 400, color: theme==='dark'?'#C1C1C1':'#3C3C3C',overflow:"hidden" }}>{props.gatewayData.data.serverName}</Typography>
                                                    </Box>
                                                    <CustomTooltip title={'Copy'} offset={[30,-20]} placement={'right-end'}>
                                                        <Button onClick={handleCopyData} value={props.gatewayData.data.serverName} style={{ fontSize: '12px',height:'32px',padding:"0px", width:"32px", fontWeight: 400, color: '#7E7E7E', alignSelf:"center",marginLeft:"0px",marginRight:"auto",marginTop:"-4px"}}><LK_Copy color='var(--GreyBaseColor)' width={"24px"} height={"24px"}/></Button>
                                                    </CustomTooltip>
                                                    {/* <Button onClick={handleCopyData} value={props.gatewayData.data.SAS} style={{ fontSize: '12px',height:'32px',padding:"0px", width:"32px", fontWeight: 400, color: '#7E7E7E', alignSelf:"center",marginLeft:"auto",marginRight:"auto"}}><ContentCopyIcon sx={{height:"24px",width:"24px"}}/></Button> */}
                                                </>
                                                :
                                                <></>
                                            }
                                        </Box>
                                        <Box className="config-form-box" sx={{padding:"4px 4px 4px 0px",width:"33.33%",boxSizing:'border-box',marginTop:"12px",}}>
                                            <Typography  style={{ fontSize: '16px', fontWeight: 400, color: theme==='dark'?'#C1C1C1':'#3C3C3C',width:"224px" }}>Port No.</Typography>
                                            {props.gatewayData.id!==""?
                                                <>
                                                    <Box className="config-form-box"style={{gap:0 ,marginTop:0,width:'calc(100% - 354px)',overflowWrap:"break-word"}} >
                                                        <Typography  style={{ fontSize: '14px', fontWeight: 400, color: theme==='dark'?'#C1C1C1':'#3C3C3C',overflow:"hidden" }}>{props.gatewayData.data.portno}</Typography>
                                                    </Box>
                                                    <CustomTooltip title={'Copy'} offset={[30,-20]} placement={'right-end'}>
                                                        <Button onClick={handleCopyData} value={props.gatewayData.data.portno} style={{ fontSize: '12px',height:'32px',padding:"0px", width:"32px", fontWeight: 400, color: '#7E7E7E', alignSelf:"center",marginLeft:"0px",marginRight:"auto",marginTop:"-4px"}}><LK_Copy color='var(--GreyBaseColor)' width={"24px"} height={"24px"}/></Button>
                                                    </CustomTooltip>
                                                    {/* <Button onClick={handleCopyData} value={props.gatewayData.data.SAS} style={{ fontSize: '12px',height:'32px',padding:"0px", width:"32px", fontWeight: 400, color: '#7E7E7E', alignSelf:"center",marginLeft:"auto",marginRight:"auto"}}><ContentCopyIcon sx={{height:"24px",width:"24px"}}/></Button> */}
                                                </>
                                                :
                                                <></>
                                            }
                                        </Box>
                                        <Box className="config-form-box" sx={{padding:"4px 4px 4px 0px",width:"66.67%",boxSizing:'border-box',marginTop:"12px",}}>
                                            <Typography  style={{ fontSize: '16px', fontWeight: 400, color: theme==='dark'?'#C1C1C1':'#3C3C3C',width:"224px" }}>Topic</Typography>
                                            {props.gatewayData.id!==""?
                                                <>
                                                    <Box className="config-form-box"style={{gap:0 ,marginTop:0,width:'calc(100% - 354px)',overflowWrap:"break-word"}} >
                                                        <Typography  style={{ fontSize: '14px', fontWeight: 400, color: theme==='dark'?'#C1C1C1':'#3C3C3C',overflow:"hidden" }}>{props.gatewayData.data.topicName}</Typography>
                                                    </Box>
                                                    <CustomTooltip title={'Copy'} offset={[30,-20]} placement={'right-end'}>
                                                        <Button onClick={handleCopyData} value={props.gatewayData.data.topicName} style={{ fontSize: '12px',height:'32px',padding:"0px", width:"32px", fontWeight: 400, color: '#7E7E7E', alignSelf:"center",marginLeft:"0px",marginRight:"auto",marginTop:"-4px"}}><LK_Copy color='var(--GreyBaseColor)' width={"24px"} height={"24px"}/></Button>
                                                    </CustomTooltip>
                                                    {/* <Button onClick={handleCopyData} value={props.gatewayData.data.SAS} style={{ fontSize: '12px',height:'32px',padding:"0px", width:"32px", fontWeight: 400, color: '#7E7E7E', alignSelf:"center",marginLeft:"auto",marginRight:"auto"}}><ContentCopyIcon sx={{height:"24px",width:"24px"}}/></Button> */}
                                                </>
                                                :
                                                <></>
                                            }
                                        </Box>
                                        <Box className="config-form-box" sx={{padding:"4px 4px 4px 0px",width:"66.67%",boxSizing:'border-box',marginTop:"12px",}}>
                                            <Typography  style={{ fontSize: '16px', fontWeight: 400, color: theme==='dark'?'#C1C1C1':'#3C3C3C',width:"224px" }}>User Name</Typography>
                                            {props.gatewayData.id!==""?
                                                <>
                                                    <Box className="config-form-box"style={{gap:0 ,marginTop:0,width:'calc(100% - 354px)',overflowWrap:"break-word"}} >
                                                        <Typography  style={{ fontSize: '14px', fontWeight: 400, color: theme==='dark'?'#C1C1C1':'#3C3C3C',overflow:"hidden" }}>{props.gatewayData.data.userName}</Typography>
                                                    </Box>
                                                    <CustomTooltip title={'Copy'} offset={[30,-20]} placement={'right-end'}>
                                                        <Button onClick={handleCopyData} value={props.gatewayData.data.userName} style={{ fontSize: '12px',height:'32px',padding:"0px", width:"32px", fontWeight: 400, color: '#7E7E7E', alignSelf:"start",marginLeft:"0px",marginRight:"auto",marginTop:"-4px"}}><LK_Copy color='var(--GreyBaseColor)' width={"24px"} height={"24px"}/></Button>
                                                    </CustomTooltip>
                                                    {/* <Button onClick={handleCopyData} value={props.gatewayData.data.SAS} style={{ fontSize: '12px',height:'32px',padding:"0px", width:"32px", fontWeight: 400, color: '#7E7E7E', alignSelf:"center",marginLeft:"auto",marginRight:"auto"}}><ContentCopyIcon sx={{height:"24px",width:"24px"}}/></Button> */}
                                                </>
                                                :
                                                <></>
                                            }
                                        </Box>
                                        <Box className="config-form-box" sx={{padding:"4px 4px 4px 0px",width:"100%",boxSizing:'border-box',marginTop:"12px",}}>
                                            <Typography  style={{ fontSize: '16px', fontWeight: 400, color: theme==='dark'?'#C1C1C1':'#3C3C3C',width:"224px" }}>Password</Typography>
                                            {props.gatewayData.id!==""?
                                                <>
                                                    <Box className="config-form-box"style={{gap:0 ,marginTop:0,width:'calc(100% - 354px)',overflowWrap:"break-word"}} >
                                                        <Typography  style={{ fontSize: '14px', fontWeight: 400, color: theme==='dark'?'#C1C1C1':'#3C3C3C',overflow:"hidden" }}>{unhidepassword===1?props.gatewayData.data.password: '*'.repeat(props.gatewayData.data.password?.length)}</Typography>
                                                    </Box>
                                                    <CustomTooltip title={unhidepassword===1?'Hide':'Unhide'} offset={[30,-20]} placement={'right-end'}>
                                                        <Button onClick={() => setUnhidePassword(unhidepassword === 1 ? 0 : 1)} sx={{ fontSize: '12px',height:'32px',padding:"0px", width:"32px", minWidth: '32px', fontWeight: 400, color: '#7E7E7E', alignSelf:"center",marginLeft:"0px",marginRight:"auto",marginTop:"-4px"}}>{unhidepassword===1?<LK_EyeClose color='var(--GreyBaseColor)' width={"24px"} height={"24px"}/>:<LK_EyeOpen color='var(--GreyBaseColor)' width={"24px"} height={"24px"}/>}</Button>
                                                    </CustomTooltip>
                                                    <CustomTooltip title={'Copy'} offset={[30,-20]} placement={'right-end'}>
                                                        <Button onClick={handleCopyData} value={props.gatewayData.data.password} style={{ fontSize: '12px',height:'32px',padding:"0px", width:"32px", fontWeight: 400, color: '#7E7E7E', alignSelf:"center",marginLeft:"-16px",marginRight:"auto",marginTop:"-4px"}}><LK_Copy color='var(--GreyBaseColor)' width={"24px"} height={"24px"}/></Button>
                                                    </CustomTooltip>
                                                    {/* <Button onClick={handleCopyData} value={props.gatewayData.data.SAS} style={{ fontSize: '12px',height:'32px',padding:"0px", width:"32px", fontWeight: 400, color: '#7E7E7E', alignSelf:"center",marginLeft:"auto",marginRight:"auto"}}><ContentCopyIcon sx={{height:"24px",width:"24px"}}/></Button> */}
                                                </>
                                                :
                                                <></>
                                            }
                                        </Box>
                                        <Box className="config-form-box" sx={{padding:"4px 4px 4px 0px",width:"33.33%",boxSizing:'border-box',marginTop:"12px",}}>
                                            <Typography  style={{ fontSize: '16px', fontWeight: 400, color: theme==='dark'?'#C1C1C1':'#3C3C3C',width:"224px" }}>QOS</Typography>
                                            {props.gatewayData.id!==""?
                                                <>
                                                    <Box className="config-form-box"style={{gap:0 ,marginTop:0,width:'calc(100% - 354px)',overflowWrap:"break-word"}} >
                                                        <Typography  style={{ fontSize: '14px', fontWeight: 400, color: theme==='dark'?'#C1C1C1':'#3C3C3C',overflow:"hidden" }}>{props.gatewayData.data.qos}</Typography>
                                                    </Box>
                                                    {/* <Button onClick={handleCopyData} value={props.gatewayData.data.qos} style={{ fontSize: '12px',height:'32px',padding:"0px", width:"32px", fontWeight: 400, color: '#7E7E7E', alignSelf:"center",marginLeft:"auto",marginRight:"auto",marginTop:"-4px"}}><LK_Copy color='var(--GreyBaseColor)' width={"24px"} height={"24px"}/></Button> */}
                                                    {/* <Button onClick={handleCopyData} value={props.gatewayData.data.SAS} style={{ fontSize: '12px',height:'32px',padding:"0px", width:"32px", fontWeight: 400, color: '#7E7E7E', alignSelf:"center",marginLeft:"auto",marginRight:"auto"}}><ContentCopyIcon sx={{height:"24px",width:"24px"}}/></Button> */}
                                                </>
                                                :
                                                <></>
                                            }
                                        </Box>
                                        <Box className="config-form-box" sx={{padding:"4px 4px 4px 0px",width:"33.33%",boxSizing:'border-box',marginTop:"12px",}}>
                                            <Typography  style={{ fontSize: '16px', fontWeight: 400, color: theme==='dark'?'#C1C1C1':'#3C3C3C',width:"224px" }}>TLS Enabled</Typography>
                                            {props.gatewayData.id!==""?
                                                <>
                                                    <Box className="config-form-box"style={{gap:0 ,marginTop:0,width:'calc(100% - 354px)',overflowWrap:"break-word"}} >
                                                        <Typography  style={{ fontSize: '14px', fontWeight: 400, color: theme==='dark'?'#C1C1C1':'#3C3C3C',overflow:"hidden" }}>{(props.gatewayData.data.tlsEnable===true?"True":"False")}</Typography>
                                                    </Box>
                                                </>
                                                :
                                                <></>
                                            }
                                        </Box>
                                        <Box className="config-form-box" sx={{padding:"4px 4px 4px 0px",width:"50%",boxSizing:'border-box',marginTop:"12px",}}>
                                            <Typography  style={{ fontSize: '16px', fontWeight: 400, color: theme==='dark'?'#C1C1C1':'#3C3C3C',width:"224px" }}>Password Expiry</Typography>
                                            {props.gatewayData.id!==""?
                                                <>
                                                    <Box className="config-form-box"style={{gap:0 ,marginTop:0,width:'calc(100% - 354px)',overflowWrap:"break-word"}} >
                                                        <Typography  style={{ fontSize: '14px', fontWeight: 400, color: theme==='dark'?'#C1C1C1':'#3C3C3C',overflow:"hidden" }}>{convertToIST(props.gatewayData.data.passwordExpiry)}</Typography>
                                                    </Box>
                                                </>
                                                :
                                                <></>
                                            }
                                        </Box>
                                        {authenticationMethodProp==='X.509'?
                                            <>
                                                <Box className="config-form-box" sx={{padding:"4px 4px 4px 0px",width:"100%",boxSizing:'border-box',marginTop:"12px",}}>
                                                    <Typography  style={{ fontSize: '16px', fontWeight: 400, color: theme==='dark'?'#C1C1C1':'#3C3C3C',width:"224px" }}>RootCACert</Typography>
                                                        <Box className="config-form-box"style={{gap:0 ,marginTop:0,width:'calc(100% - 354px)',overflowWrap:"break-word"}} >
                                                            <Typography  style={{ fontSize: '14px', fontWeight: 400, color: theme==='dark'?'#C1C1C1':'#3C3C3C',overflow:"hidden" }}>{props.gatewayData.data.SAS}</Typography>
                                                            <CustomUploadButton/>
                                                        </Box>
                                                </Box>
                                            </>
                                            :
                                            <></>
                                        }
                                    </>
                                
                                :
                                <></>
                            }
                        </Box>
                        :
                        <></>
                    } 
                    <Typography className="config-heading" style={{ fontSize: '20px', fontWeight: 400, color: "#008CD7",padding:"4px",marginTop:"20px" }}>Connection Details<Button onClick={()=>{(connectionDetails===1)?setconnectionDetails(0):setconnectionDetails(1)}}>{(connectionDetails===1)?<ExpandLessOutlinedIcon style={{width: '28px', height: '28px',fontWeight: 700, color: "#008CD7",}} /> : <ExpandMoreOutlinedIcon style={{width: '28px', height: '28px',fontWeight: 700, color: "#008CD7",}}/>}</Button></Typography>
                    {connectionDetails===1?
                        <Box  style={{overflow:"auto"}} sx={{display:"flex",gap:'0px',flexWrap:'wrap',padding:"4px 4px 12px 4px",backgroundColor:theme==='dark'?'#3C3C3C40':'#FFFFFF80'}}>
                            <Box className="config-form-box" sx={{padding:"4px 4px 4px 0px",width:"33.33%",boxSizing:'border-box',marginTop:"12px"}} >
                                <Box className="config-form-box" style={{gap:'4px',marginTop:0}} >
                                    <Box style={{marginTop:"-2.05px"}} >
                                        <CustomCheckbox defaultChecked={props.gatewayData.id!==""?props.gatewayData.data.enable:gatewayinfo.data.enable} onChange={handleGatewayEnable}></CustomCheckbox>
                                    </Box>
                                    <Typography  style={{ fontSize: '16px', fontWeight: 400, color: theme==='dark'?'#C1C1C1':'#3C3C3C',width:"224px" }}>Enable Gateway</Typography>
                                </Box>
                            </Box>
                            <Box className="config-form-box" sx={{padding:"4px 4px 4px 0px",width:"33.33%",boxSizing:'border-box',marginTop:"12px"}}>
                                <Typography  style={{ fontSize: '16px', fontWeight: 400, color: theme==='dark'?'#C1C1C1':'#3C3C3C',width:"224px" }}>Connection State</Typography>
                                <Box className="config-form-box"style={{gap:0 ,marginTop:0}} >
                                    <Typography  style={{ fontSize: '16px', fontWeight: 400, color:((props.gatewayData.data.enable==="true" || props.gatewayData.data.enable===true) && props.gatewayData.id!=="")?handleConnectionStatus(props.gatewayData.id,connState)===true?"#00943d":"#dc272d":"#dc272d"  }}>{((props.gatewayData.data.enable==="true" || props.gatewayData.data.enable===true) && props.gatewayData.id!=="")?handleConnectionStatus(props.gatewayData.id,connState)===true?"Connected":"Not Connected":"Not Connected"}</Typography>
                                </Box>
                            </Box>
                        </Box>
                        :
                        <></>
                    }
                    <Typography className="config-heading" style={{ fontSize: '20px', fontWeight: 400, color: "#008CD7",padding:"4px",marginTop:"20px" }}>Payload Details<Button onClick={()=>{(payloadDetails===1)?setPayloadDetails(0):setPayloadDetails(1)}}>{(payloadDetails===1)?<ExpandLessOutlinedIcon style={{width: '28px', height: '28px',fontWeight: 700, color: "#008CD7",}} /> : <ExpandMoreOutlinedIcon style={{width: '28px', height: '28px',fontWeight: 700, color: "#008CD7",}}/>}</Button></Typography>
                    {payloadDetails===1?
                        <Box  style={{overflow:"auto"}} sx={{display:"flex",gap:'0px',flexWrap:'wrap',padding:"4px 4px 12px 4px",backgroundColor:theme==='dark'?'#3C3C3C40':'#FFFFFF80'}}>
                            <Box className="config-form-box" sx={{padding:"4px 4px 4px 0px",width:"100%",boxSizing:'border-box',marginTop:"12px"}} >
                                <Typography  style={{ fontSize: '16px', fontWeight: 400, color: theme==='dark'?'#C1C1C1':'#3C3C3C' ,width:"224px"}}>Payload</Typography>
                                <Box  style={{marginTop:0,width:'calc(100% - 224px)'}}>
                                    <pre style={{color: theme==='dark'?'#C1C1C1':'#3C3C3C',maxHeight:'250px',fontSize: '16px',fontFamily:'Roboto',lineHeight:'24px'}}>{JSON.stringify(payloadStructure, undefined, 8)}</pre>
                                </Box>
                            </Box>
                        </Box>
                        :
                        <></>
                    }
                    {/* <Typography className="config-heading" style={{ fontSize: '20px', fontWeight: 400, color: "#008CD7",padding:"4px",marginTop:"20px" }}> Plant Hierarchy<Button onClick={()=>{(plantHierarchy==1)?setPlantHierarchy(0):setPlantHierarchy(1)}}>{(plantHierarchy==1)?<ExpandLessOutlinedIcon style={{width: '28px', height: '28px',fontWeight: 700, color: "#008CD7",}} /> : <ExpandMoreOutlinedIcon style={{width: '28px', height: '28px',fontWeight: 700, color: "#008CD7",}}/>}</Button></Typography>
                    {plantHierarchy==1?
                        <Box  style={{overflow:"auto"}} sx={{display:"flex",gap:'0px',flexWrap:'wrap',padding:"4px 4px 12px 4px",backgroundColor:theme==='dark'?'#3C3C3C40':'#FFFFFF80'}}>
                            <Box className="config-form-box" sx={{padding:"4px 4px 4px 0px",width:"100%",boxSizing:'border-box',marginTop:"12px"}} >
                                <Typography  style={{ fontSize: '16px', fontWeight: 400, color: theme==='dark'?'#C1C1C1':'#3C3C3C' ,width:"224px"}}></Typography>
                                {/* <Box  style={{marginTop:0,width:'calc(100% - 224px)'}}>
                                    {payloadStructure.map((val,index) => (
                                        <>
                                            <Typography sx={{color: theme==='dark'?'#C1C1C1':'#3C3C3C',maxHeight:'250px'}} style={{whiteSpace: 'pre-line'}}>{payloadStructure[0]}</Typography>
                                        </>
                                    ))}
                                </Box> *}
                            </Box>
                        </Box>
                        :
                        <></>
                    } */}
        </Box>
      </Box>
    );
  };

  const GatewayCard = (props) => {
    const [anchorEl, setAnchorEl] = useState(null);
    const open = Boolean(anchorEl);
    const [openDevicesList, setOpenDevicesList] = React.useState(false);
    const [devicesAssociated, setDevicesAssociated] = React.useState([]);

    const handleGatewayCardMore = (event) => {
      setAnchorEl(event.currentTarget);
    };

    const handleCloseMenu = () => {
      setAnchorEl(null);
    };

    const handleGatewayEdit = () => {
      const temp = {
        ...props.gatewaylist,
        data: {
          ...props.gatewaylist.data,
          connectionMethod: props.gatewaylist.data.connectionMethod,
        },
      };
      setGatewayInfo(temp);
      setOpenForm(1);
    };

    function handleDeleteCheck(selected) {
      const temp = [...deleteGatewayArr];
      if (selected === true) {
        temp.push(props.gatewaylist.id);
        setDeleteGatewayArr(temp);
      } else {
        setDeleteGatewayArr(temp.filter((val) => val !== props.gatewaylist.id));
      }
    }

        function handleOpenDeviceList(){
            setAnchorEl(null);
            setOpenDevicesList(true)
            let temp=[]
            temp = devicelist.filter(val => val.gatewayId===props.gatewaylist.id)
            setDevicesAssociated(temp);
        }
        
        useEffect(()=>{
            if(deleteGateway===2){
            }
        },[deleteGateway]);

        
        return (
            <Box key={props.index} sx={{display:'flex', flexDirection:'row', height:'125px'/*180*/,width:'calc(25% - 6px)',minWidth:"300px"/*394.5px */,textAlign:'left',boxSizing:'border-box',overflowWrap:"break-word"}}>
                <Box sx={{height:"100%", width:"1.6%",background:(props.gatewaylist.data.enable==="true" || props.gatewaylist.data.enable===true)?handleConnectionStatus(props.gatewaylist.id,connState)?"var(--GreenBaseColor)":"var(--RedBaseColor)":"var(--GreyBaseColor)"}}></Box>
                <Box key={props.index} sx={{display:'flex', flexDirection:'column', height:'100%',width:'98.4%',background:'var(--SecondaryBackground)',padding:'10px 10px 10px 10px',textAlign:'left',boxSizing:'border-box',overflowWrap:"break-word"}}>
                    <Box  sx={{display:'flex', flexDirection:'row',width:'100%',gap:"4px"}}>
                            <Box sx={{marginTop:'-2.58px',marginRight:'4px'}}>
                                <CustomCheckbox defaultChecked={deleteGatewayArr.includes(props.gatewaylist.id)===true?true:false} onChange={handleDeleteCheck} width={15} height={15}/>
                            </Box>
                        <CustomTooltip title={props.gatewaylist.data.gatewayName} ifOverflow={true} offset={[30,-20]} placement={'right-end'}>
                        <Typography sx={{fontFamily:'Roboto',fontSize:'20px',fontWeight:'700',color:'var(--PrimaryText)',marginTop:'-4px',whiteSpace: 'nowrap', textOverflow: 'ellipsis', overflow: 'hidden'}}>{props.gatewaylist.data.gatewayName}</Typography> 
                        </CustomTooltip>
                        <Box style={{flexGrow: 1}}></Box>
                        <Button
                            id="basic-button"
                            aria-controls={open ? 'basic-menu' : undefined}
                            aria-haspopup="true"
                            aria-expanded={open ? 'true' : undefined}
                            onClick={handleGatewayCardMore}
                            disabled={disableButtons!==0?true:false}
                            style={{postion:"inline",height:"19px",maxWidth:"16px",minWidth:'16px',fontSize:'12px',fontWeight:'700',color:disableButtons!==0?theme === 'light' ? '#C1C1C1' : '#3C3C3C':'var(--PrimaryText)',textTransform:'none',padding:0,margin:0}}
                        >
                            <MoreVertIcon sx={{height:"20px",width:"20px"}}/>
                        </Button>
                        <Menu
                            id="basic-menu"
                            anchorEl={anchorEl}
                            open={open}
                            onClose={handleCloseMenu}
                            MenuListProps={{
                            'aria-labelledby': 'basic-button',
                            }}
                            PaperProps={{
                                component: 'form',
                                sx:{
                                    borderRadius:0,
                                    bgcolor:theme==='dark'?'#000000':'#FFFFFF',
                                    maxHeight:'150px',
                                    maxWidth:'150px',
                                    width:"130px",
                                    height:"90px",
                                    overflow:'auto',
                                    color:theme==='dark'?'#C1C1C1':'#7E7E7E',
                                    padding:"0px 0px 0px 0px",
                                    overflow:'auto',
                                    '::-webkit-scrollbar': {width: '4px',height: '4px'},
                                    '::-webkit-scrollbar-track': {borderRadius: '0px',background: theme==='dark'?'#3c3c3c':'#c1c1c1'},
                                    '::-webkit-scrollbar-thumb': {background:'#7e7e7e',borderRadius: '5px',height:'auto'}
                                }
                                }}
                            style={{'::-webkit-scrollbar-track': {
                                background: '#000000'
                            }}}
                            sx={{'&.MuiList-root MuiList-padding MuiMenu-list':{ padding:"0px 0px 0px 0px"},}}
                        >
                            <MenuItem onClick={handleGatewayEdit} id={props.index}>Edit</MenuItem>
                            {/* <Divider variant="middle" style={{margin:"0px 2px 0px 2px", background:theme==='dark'?'#3C3C3C':'#EFEFEF'}}/>
                            <MenuItem onClick={handleGatewayDelete} id={props.index}>Delete</MenuItem> */}
              <Divider
                variant="middle"
                style={{
                  margin: "0px 2px 0px 2px",
                  background: theme === "dark" ? "#3C3C3C" : "#EFEFEF",
                }}
              />
              <MenuItem onClick={handleOpenDeviceList} id={props.index}>
                Device List
              </MenuItem>
              <Divider
                variant="middle"
                style={{
                  margin: "0px 2px 0px 2px",
                  background: theme === "dark" ? "#3C3C3C" : "#EFEFEF",
                }}
              />
              <MenuItem onClick={handleClone} id={props.index}>
                Clone Gateway
              </MenuItem>
              {/* <Divider variant="middle" style={{margin:"0px 2px 0px 2px", background:theme==='dark'?'#3C3C3C':'#EFEFEF'}}/>
                            <MenuItem onClick={() =>  navigator.clipboard.writeText(props.gatewaylist.data.SAS)}  id={props.index}>Copy Token</MenuItem>
                            <Divider variant="middle" style={{margin:"0px 2px 0px 2px", background:theme==='dark'?'#3C3C3C':'#EFEFEF'}}/>
                            <MenuItem onClick={() =>  navigator.clipboard.writeText(props.gatewaylist.data.primaryConnectionString)}  id={props.index}>Copy String</MenuItem> */}
                        </Menu>
                        <Dialog
                            open={openDevicesList===true}
                            onClose={()=>(setOpenDevicesList(false))}
                            PaperProps={{
                            component: 'form',
                            sx:{
                                borderRadius:0,
                                bgcolor:theme==='dark'?'#1E1E1E':'#FFFFFF',
                                maxHeight:'850px',
                                maxWidth:'1950px',
                                width:"1150px",
                                height:"800px",
                                overflow:'auto',
                                color:theme==='dark'?'#C1C1C1':'#7E7E7E',
                            }
                            }}
                        >
                            <DialogTitle sx={{fontSize: '24px', fontWeight: 700, color: "#008CD7",padding:"16px"}}>Device List</DialogTitle>
                            <DialogContent sx={{/*overflow:"hidden",*/marginBottom:"8px",padding:"16px",width:"100%",boxSizing:'border-box'}}>
                                <Typography className="config-heading" style={{ fontSize: '20px', fontWeight: 400, color:  theme==='dark'?'#C1C1C1':'#3C3C3C', marginBottom:"12px"/*lineHeight:"42.19px"*/ }}>{props.gatewaylist.data.gatewayName}</Typography>
                                <Box  sx={{display:'flex', flexDirection:'column',width:'100%',gap:"4px",padding:"0px",boxSizing:'border-box'}}>
                                    <Box  sx={{display:'flex', flexDirection:'row',width:`calc(100% - 4px)`,gap:"16px",padding:"4px 0px",boxSizing:'border-box',overflowWrap:"break-word"}}>
                                        <Typography className="config-heading" style={{ fontSize: '16px', fontWeight: 700, color:  theme==='dark'?'#C1C1C1':'#3C3C3C', /*lineHeight:"42.19px",*/ width:'5%' }}>Sr.No.</Typography>
                                        <Typography className="config-heading" style={{ fontSize: '16px', fontWeight: 700, color:  theme==='dark'?'#C1C1C1':'#3C3C3C', /*lineHeight:"42.19px",*/ width:'25%' }}>Device Name</Typography>
                                        <Typography className="config-heading" style={{ fontSize: '16px', fontWeight: 700, color:  theme==='dark'?'#C1C1C1':'#3C3C3C', /*lineHeight:"42.19px",*/ width:'15%' }}>Device ID</Typography>
                                        <Typography className="config-heading" style={{ fontSize: '16px', fontWeight: 700, color:  theme==='dark'?'#C1C1C1':'#3C3C3C', /*lineHeight:"42.19px",*/ width:'20%' }}>Serial No.</Typography>
                                        <Typography className="config-heading" style={{ fontSize: '16px', fontWeight: 700, color:  theme==='dark'?'#C1C1C1':'#3C3C3C', /*lineHeight:"42.19px",*/ width:'15%' }}>Connection Status</Typography>
                                        <Typography className="config-heading" style={{ fontSize: '16px', fontWeight: 700, color:  theme==='dark'?'#C1C1C1':'#3C3C3C', /*lineHeight:"42.19px",*/ width:'20%' }}>Last Connection Status </Typography>
                                    </Box>
                                    <Divider variant="middle" style={{margin:"0px 0px 0px 0px",height:"1px", background:theme==='dark'?'#3C3C3C':'#EFEFEF'}}/>
                                    <Box sx={{display:'flex', flexDirection:'column',width:'100%',gap:"4px",padding:"0px",maxHeight:'555px',boxSizing:'border-box',overflow:'auto','::-webkit-scrollbar': {width: '4px',height: '4px'},'::-webkit-scrollbar-track': {borderRadius: '0px',background: theme==='dark'?'#3c3c3c':'#c1c1c1'},'::-webkit-scrollbar-thumb': {background: '#7e7e7e',borderRadius: '5px',height:'auto'}}}>
                                    {devicesAssociated.length!==-1?
                                    <>
                                        {devicesAssociated.map((val,index) => (
                                            <>
                                            <Box  sx={{display:'flex', flexDirection:'row',width:'100%',gap:"16px",padding:"4px 0px",boxSizing:'border-box',overflowWrap:"break-word"}}>
                                                <Typography className="config-heading" style={{ fontSize: '16px', fontWeight: 400, color:  theme==='dark'?'#C1C1C1':'#3C3C3C', /*lineHeight:"42.19px",*/ width:'5%' ,whiteSpace: 'nowrap', textOverflow: 'ellipsis', overflow: 'hidden'}}>{index+1}</Typography>
                                                <Typography className="config-heading" style={{ fontSize: '16px', fontWeight: 400, color:  theme==='dark'?'#C1C1C1':'#3C3C3C', /*lineHeight:"42.19px",*/ width:'25%',whiteSpace: 'nowrap', textOverflow: 'ellipsis', overflow: 'hidden' }}>{val.deviceName}</Typography>
                                                <Typography className="config-heading" style={{ fontSize: '16px', fontWeight: 400, color:  theme==='dark'?'#C1C1C1':'#3C3C3C', /*lineHeight:"42.19px",*/ width:'15%',whiteSpace: 'nowrap', textOverflow: 'ellipsis', overflow: 'hidden' }}>{val.deviceId}</Typography>
                                                <Typography className="config-heading" style={{ fontSize: '16px', fontWeight: 400, color:  theme==='dark'?'#C1C1C1':'#3C3C3C', /*lineHeight:"42.19px",*/ width:'20%' ,whiteSpace: 'nowrap', textOverflow: 'ellipsis', overflow: 'hidden'}}>{val.serialno}</Typography>
                                                <Typography className="config-heading" style={{ fontSize: '16px', fontWeight: 400, color:  (val.enable===true || val.enable==="true")?val.status===1?"#00943d":"#dc272d":"#dc272d", /*lineHeight:"42.19px",*/ width:'15%' ,whiteSpace: 'nowrap', textOverflow: 'ellipsis', overflow: 'hidden'}}>{(val.enable===true || val.enable==="true")?val.status===1?"Connected":"Not Connected":"Not Connected"}</Typography>
                                                <Typography className="config-heading" style={{ fontSize: '16px', fontWeight: 400, color:  theme==='dark'?'#C1C1C1':'#3C3C3C', /*lineHeight:"42.19px",*/ width:'20%' ,whiteSpace: 'nowrap', textOverflow: 'ellipsis', overflow: 'hidden'}}>{convertToIST(val.statusLastUpdated)}</Typography>
                                            </Box>
                                            <Divider variant="middle" style={{margin:"0px 0px 0px 0px",height:"1px", background:theme==='dark'?'#3C3C3C':'#EFEFEF'}}/>
                                           </>
                                        ))}
                                    </>
                                    :
                                    <></>
                                    }
                                    </Box>
                                </Box>
                            </DialogContent>
                            <DialogActions>
                                 {/* <CustomButton onClick={()=>(setOpenDevicesList(false))} buttonText={'Save'}/> */}
                                 <CustomCancelButton onClick={()=>(setOpenDevicesList(false))} buttonText={'Cancel'}></CustomCancelButton>
                             </DialogActions>
                        </Dialog>
                        {/* <GatewayForm /*formType={"Edit"} index={props.index} openForm={openEditForm}* closeForm={handleCloseEditForm} saveForm={handleSaveEditForm} gatewayData={gatewayData}/> */}
                    </Box> 
                    <Box  sx={{display:'flex', flexDirection:'row',width:'calc(100% - 8px)',fontFamily:"Roboto",margin:"0px 0px 0px 0px",boxSizing:'border-box',gap:"16px"}}>
                        <CustomTooltip title={props.gatewaylist.id} inputTitle={`Gateway ID: ${props.gatewaylist.id}`} ifOverflow={true} offset={[30,-20]} placement={'right-end'}>
                            <Typography className="config-heading" style={{ fontSize: '16px', fontWeight: 400, color: "var(--PrimaryText)",lineHeight:"28px" ,width:"50%",whiteSpace: 'nowrap', textOverflow: 'ellipsis', overflow: 'hidden' }}>Gateway ID: {props.gatewaylist.id}</Typography>
                        </CustomTooltip>
                        <CustomTooltip title={props.gatewaylist.data.serialNo} inputTitle={`Serial no: ${props.gatewaylist.data.serialNo}`} ifOverflow={true} offset={[30,-20]} placement={'right-end'}>
                            <Typography className="config-heading" style={{ fontSize: '16px', fontWeight: 400, color: "var(--PrimaryText)",lineHeight:"28px" ,width:"50%",whiteSpace: 'nowrap', textOverflow: 'ellipsis', overflow: 'hidden' }}>Serial no: {props.gatewaylist.data.serialNo}</Typography>
                        </CustomTooltip>
                    </Box>
                    <Typography className="config-heading" style={{ fontSize: '16px', fontWeight: 700, color: "var(--PrimaryText)", marginRight:"24px",/*marginTop:"16px"*/ marginTop:"8px"}}>Devices</Typography>
                    <Box  sx={{display:'flex', flexDirection:'row',width:'100%',fontSize:"16px",fontFamily:"Roboto",margin:"0px 0px 12px 0px",flexWrap:'wrap'}}>
                        {/* <Box sx={{display:'flex', flexDirection:'row',width:'50%'}}>
                            <Typography className="config-heading" style={{ fontSize: '16px', fontWeight: 400, color: "var(--GreyVariation_4)", marginRight:"12px" }}>Total</Typography>
                            <Typography className="config-heading" style={{ fontSize: '16px', fontWeight: 400, color: "var(--PrimaryText)", marginRight:"20px" }}>00</Typography>
                        </Box>
                        <Box sx={{display:'flex', flexDirection:'row',width:'50%'}}>
                            <Typography className="config-heading" style={{ fontSize: '16px', fontWeight: 400, color: "var(--GreyVariation_4)", marginRight:"12px" }}>Enabled</Typography>
                            <Typography className="config-heading" style={{ fontSize: '16px', fontWeight: 400, color: "var(--GreyVariation_3)", marginRight:"20px" }}>00</Typography>
                        </Box>
                        <Box sx={{display:'flex', flexDirection:'row',width:'50%'}}>
                            <Typography className="config-heading" style={{ fontSize: '16px', fontWeight: 400, color: "var(--GreyVariation_4)", marginRight:"12px" }}>Connected</Typography>
                            <Typography className="config-heading" style={{ fontSize: '16px', fontWeight: 400, color: "var(--GreenBaseColor)", marginRight:"20px" }}>00</Typography>
                        </Box>
                        <Box sx={{display:'flex', flexDirection:'row',width:'50%'}}>
                            <Typography className="config-heading" style={{ fontSize: '16px', fontWeight: 400, color: "var(--GreyVariation_4)", marginRight:"12px" }}>Disconnected</Typography>
                            <Typography className="config-heading" style={{ fontSize: '16px', fontWeight: 400, color: "var(--RedBaseColor)", marginRight:"20px" }}>00</Typography>
                        </Box> */}
            <Typography
              className="config-heading"
              style={{
                fontSize: "16px",
                fontWeight: 400,
                color: "var(--PrimaryText)",
                marginRight: "20px",
              }}
            >
              {
                devicelist.filter(
                  (val) => val.gatewayId === props.gatewaylist.id,
                ).length
              }
            </Typography>
            <Typography
              className="config-heading"
              style={{
                fontSize: "16px",
                fontWeight: 400,
                color: "var(--GreyVariation_3)",
                marginRight: "20px",
              }}
            >
              {
                devicelist.filter(
                  (val) =>
                    val.gatewayId === props.gatewaylist.id &&
                    (val.enable === true || val.enable === "true"),
                ).length
              }
            </Typography>
            <Typography
              className="config-heading"
              style={{
                fontSize: "16px",
                fontWeight: 400,
                color: "var(--GreenBaseColor)",
                marginRight: "20px",
              }}
            >
              {
                devicelist.filter(
                  (val) =>
                    val.gatewayId === props.gatewaylist.id &&
                    (val.enable === true || val.enable === "true") &&
                    val.status === 1,
                ).length
              }
            </Typography>
            <Typography
              className="config-heading"
              style={{
                fontSize: "16px",
                fontWeight: 400,
                color: "var(--RedBaseColor)",
                marginRight: "20px",
              }}
            >
              {
                devicelist.filter(
                  (val) =>
                    val.gatewayId === props.gatewaylist.id &&
                    (val.enable === true || val.enable === "true") &&
                    val.status === 0,
                ).length
              }
            </Typography>
          </Box>
          {/* <Typography className="config-heading" style={{ fontSize: '16px', fontWeight: 700, color: "var(--PrimaryText)" }}>Gateway Details</Typography>
                    <Box  sx={{display:'flex', flexDirection:'row',width:'calc(100% - 8px)',fontFamily:"Roboto",margin:"2px 0px 12px 0px",boxSizing:'border-box',gap:"16px"}}>
                        <Typography className="config-heading" style={{ fontSize: '16px', fontWeight: 400, color: "var(--PrimaryText)",lineHeight:"28px" ,width:"50%",whiteSpace: 'nowrap', textOverflow: 'ellipsis', overflow: 'hidden' }}>Gateway ID: {props.gatewaylist.id}</Typography>
                        <Typography className="config-heading" style={{ fontSize: '16px', fontWeight: 400, color: "var(--PrimaryText)",lineHeight:"28px" ,width:"50%",whiteSpace: 'nowrap', textOverflow: 'ellipsis', overflow: 'hidden' }}>Serial no: {props.gatewaylist.data.serialNo}</Typography>
                    </Box> */}
        </Box>
      </Box>
    );
  };

  useEffect(() => {
    let ids = [];
    gatewayno.map((val) => {
      if (val.data.enable === "true" || val.data.enable === true) {
        ids = [...ids, val.id];
      }
    });
    gatewaylivedata(ids, gatewaystatuscallback);
  }, [gatewayno]);

  function gatewaystatuscallback(res) {
    setConnState(res.data);
  }

    return(
        <Box className="compliance-config" sx={{height :"100%",boxSizing:"border-box",width:'100%'}}>
            {saveStatus!==0?
                <>
                    <CustomToast openToast={saveStatus!==0} type={ saveStatus===1?"Success":"Error"} autoHideDuration={10000} toastText={saveStatus===1?"Saved Successfully!":"Save Failed"} onClose={handleToastClose}/>
                    {/* <Typography sx={{color: saveStatus===1? theme==='dark'?'#C1C1C1':'#3C3C3C':"#DC272D",alignSelf:"start",height:"35px",textAlign:"center",alignContent:"center"}}>{saveStatus===1?"Saved Successfully!":"Save Failed"}</Typography> */}
                </>
                :
                <></>
            }
            {deleteSuccess!==0?<CustomToast openToast={deleteSuccess!==0} type={deleteSuccess===1?"Success":"Error"} toastText={deleteSuccess===1?"Deleted Successfully!":"Delete Failed"} onClose={handleDeleteToastClose}/>:<></>}
            <CustomToast openToast={copyStatus!==0} type={"Success"} toastText={"Copied Successfully!"} onClose={() => setCopyStatus(0)}/>
            <Box  sx={{padding:"0px",height:'calc(100% - 0px)',width:"100%" ,boxSizing:"border-box"}} >
                <Box  sx={{padding:"0px",width:'100%',height:"7%" ,boxSizing:"border-box",display:"flex"}} >
                    {openForm===0?
                        <>
                            <Box  sx={{display:'flex', flexDirection:'row',width:'100%',fontSize:"16px",fontFamily:"Roboto",margin:"0px",alignSelf:"center" }}>
                                <Typography className="config-heading" style={{ fontSize: '16px', fontWeight: 400, color: "var(--GreyVariation_4)", marginRight:"12px",alignContent:"end" }}>Total</Typography>
                                <Typography className="config-heading" style={{ fontSize: '20px', fontWeight: 400, color: "var(--PrimaryText)", marginRight:"40px" }}>{gatewayno.length}</Typography>
                                <Typography className="config-heading" style={{ fontSize: '16px', fontWeight: 400, color: "var(--GreyVariation_4)", marginRight:"12px",alignContent:"end" }}>Enabled</Typography>
                                <Typography className="config-heading" style={{ fontSize: '20px', fontWeight: 400, color: "var(--GreyVariation_3)", marginRight:"20px" }}>{gatewayno.filter(gatewayno => (gatewayno.data.enable==="true" || gatewayno.data.enable===true)).length}</Typography>
                                <Typography className="config-heading" style={{ fontSize: '16px', fontWeight: 400, color: "var(--GreyVariation_4)", marginRight:"12px",alignContent:"end" }}>Connected</Typography>
                                <Typography className="config-heading" style={{ fontSize: '20px', fontWeight: 400, color: "var(--GreenBaseColor)", marginRight:"20px" }}>{connState.filter(value => value[1]==="Connected").length}</Typography>
                                <Typography className="config-heading" style={{ fontSize: '16px', fontWeight: 400, color: "var(--GreyVariation_4)", marginRight:"12px",alignContent:"end" }}>Not Connected</Typography> {/*Disconnected*/}
                                {/* <Typography className="config-heading" style={{ fontSize: '20px', fontWeight: 400, color: "var(--RedBaseColor)", marginRight:"20px" }}>{gatewayno.filter(gatewayno => (gatewayno.data.enable === "true" || gatewayno.data.enable===true) && gatewayno.data.connectionState == "Disconnected").length}</Typography> */}
                                <Typography className="config-heading" style={{ fontSize: '20px', fontWeight: 400, color: "var(--RedBaseColor)", marginRight:"20px" }}>{connState.filter(value => value[1]==="Disconnected").length}</Typography>
                            </Box>
                            <Box sx={{flexGrow:1,height:'24px',alignSelf:"center"}}></Box> 
                            <CustomTooltip title={"Refresh"} offset={[30,-20]} placement={'right-end'}>
                                <Button onClick={handleRefresh} disabled={disableButtons!==0?true:false} sx={{width:'40px','& .MuiButtonBase-root.MuiButton-root':{width:'40px'},padding:0}} style={{ fontSize: '12px',height:'28px',minWidth:'44px',width:'40px',fontWeight: 400,alignSelf:"center",marginLeft:"auto",marginRight:"auto",marginTop:'-8px'}}><LK_Refresh color={disableButtons!==0?theme === 'light' ? '#C1C1C1' : '#3C3C3C':'var(--LK_BrandBlue)'} width={"28px"} height={"28px"}/></Button>
                            </CustomTooltip>
                            <CustomTooltip title={"Add"} offset={[30,-20]} placement={'right-end'}>
                                <Button onClick={()=>setOpenForm(1)} disabled={disableButtons!==0?true:false} sx={{width:'40px','& .MuiButtonBase-root.MuiButton-root':{width:'40px'},padding:0}} style={{ fontSize: '12px',height:'28px',minWidth:'44px',width:'40px',fontWeight: 400,alignSelf:"center",marginLeft:"auto",marginRight:"auto",marginTop:'-8px'}}><LK_Add color={disableButtons!==0?theme === 'light' ? '#C1C1C1' : '#3C3C3C':'var(--LK_BrandBlue)'} width={"28px"} height={"28px"}/></Button>
                            </CustomTooltip>
                            <CustomTooltip title={"Select All"} offset={[30,-20]} placement={'right-end'}>
                                <Button onClick={handleSelectAllGateways} disabled={(disableButtons!==0 && disableButtons!==1)?true:false} style={{ fontSize: '12px',height:'40px',width:'40px',minWidth:'40px', fontWeight: 400,alignSelf:"center",marginLeft:"-0px",marginRight:"0",marginTop:'-8px'}}><LK_Select color={(disableButtons!==0 && disableButtons!==1)?theme === 'light' ? '#C1C1C1' : '#3C3C3C':'var(--LK_BrandBlue)'} width={"36px"} height={"36px"}/></Button>
                            </CustomTooltip>
                            <CustomTooltip title={"Delete"} offset={[30,-20]} placement={'right-end'}>
                                <Button onClick={handleDeleteSelected} disabled={(disableButtons!==0 && disableButtons!==1)?true:false} style={{ fontSize: '12px',boxSizing:'border-box',padding:0,height:'36px',width:'36px',minWidth:'36px', fontWeight: 400,alignSelf:"center",marginLeft:"-4px",marginRight:"0",marginTop:'-8px'}}><LK_Delete color={(disableButtons!==0 && disableButtons!==1)?theme === 'light' ? '#C1C1C1' : '#3C3C3C':'var(--LK_BrandBlue)'} width={"36px"} height={"36px"}/></Button>
                            </CustomTooltip>
                            <CustomDialogBox dialogTitle={"Delete Conformation"} dialogText={"Are you sure you want to delete "+ deleteGatewayArr.length + " gateway" + (deleteGatewayArr.length>1?"s":"")} openDialog={deleteConfimed===1} handleCloseDialog={handleDeleteCancel} handleConfirmDialog={handleDeleteConfirmed} confirmText={"OK"} cancelText={"Cancel"} type={"Warning"}/>
                            <CustomDialogBox dialogTitle={"Delete Conformation"} dialogText={"Please select gateways for deletion"} openDialog={deleteConfimed===2} handleCloseDialog={handleDeleteCancel} handleConfirmDialog={()=>{setDeleteConfirmed(0)}} confirmText={"OK"} cancelText={"Cancel"} type={"Warning"}/>
                            <CustomDialogBox dialogTitle={"No Gateways Selected"} dialogText={"No Gateways selected for deselection"} openDialog={deleteConfimed===3} handleCloseDialog={()=>{setDeleteConfirmed(0)}} handleConfirmDialog={()=>{setDeleteConfirmed(0)}} confirmText={"OK"} cancelText={"Cancel"} type={"Warning"}/>
                            <CustomTooltip title={"Deselect All"} offset={[30,-20]} placement={'right-end'}>
                                <Button onClick={handleDeleteCancel} disabled={(disableButtons!==0 && disableButtons!==1)?true:false} style={{ fontSize: '12px',height:'28px',width:'40px', fontWeight: 400,alignSelf:"center",marginLeft:"-6px",minWidth:'44px',marginRight:"0",marginTop:'-8px'}}><LK_Close color={(disableButtons!==0 && disableButtons!==1)?theme === 'light' ? '#C1C1C1' : '#3C3C3C':'var(--LK_BrandBlue)'} width={"24px"} height={"24px"}/></Button>
                            </CustomTooltip>
                            {/* setdisableButtons */}
                            <Box sx={{display:'flex', flexDirection:'row',width:'30%',fontSize:"16px",fontFamily:"Roboto",marginTop:"-4px",alignSelf:"center" ,gap:"8px", alignItems:"center"}}>
                                <CustomTextField id={'negative-feedback'} disabled={((disableButtons!==0 && disableButtons!==1))?true:false} onChange={handleSearchText} defaultValue={ifsearching===0?"":search.searchText}  placeholder={"search"} width={180}/> 
                                <CustomDropDown options={filter} disabled={((disableButtons!==0 && disableButtons!==1))?true:false} onChange={handleFilterSelected} defaultValue={ifsearching===0?"":search.filterSelected} width={"180px"}></CustomDropDown>   
                                <CustomTooltip title={"Deselect All"} offset={[30,-20]} placement={'right-end'}>
                                    <Button onClick={handleSearchClick} disabled={((disableButtons!==0 && disableButtons!==1))?true:false} style={{ fontSize: '12px',width:"40px",minWidth:"40px",fontWeight: 400, color: 'var(--Searchtext_muted)', fontFamily: 'Roboto', textAlign:'left',justifySelf:"right",cursor: 'pointer',textTransform:'none' ,marginLeft:"0px",padding:0}}><LK_Search color={((disableButtons!==0 && disableButtons!==1))?theme === 'light' ? '#C1C1C1' : '#3C3C3C':'var(--LK_BrandBlue)'} width={"28px"} height={"28px"}/></Button> 
                                </CustomTooltip>
                                {ifsearching===1?<Button onClick={handleSearchCancel} disabled={((disableButtons!==0 && disableButtons!==1))?true:false} style={{ fontSize: '12px',width:"34px",minWidth:"34px", fontWeight: 400, color: 'var(--Searchtext_muted)', fontFamily: 'Roboto', textAlign:'left',justifySelf:"right",cursor: 'pointer',textTransform:'none' ,marginLeft:"-8px",padding:0}}><LK_Close color={(disableButtons!==0 && disableButtons!==1)?theme === 'light' ? '#C1C1C1' : '#3C3C3C':'var(--LK_BrandBlue)'} width={"24px"} height={"24px"}/></Button>:<></> }
                            </Box>
                        </>
                        :
                        <Box sx={{display:"flex",gap:'8px',width:'100%',height:"100%"}}>
                            <Box sx={{flexGrow:1}}></Box>
                            <CustomDialogBox dialogTitle={"Required fields not filled"} dialogText={"Required fields to must be filled"} openDialog={required===1} handleCloseDialog={()=>setRequired(0)} handleConfirmDialog={()=>setRequired(0)} confirmText={"OK"} cancelText={"Cancel"} type={"Warning"}/>
                            <CustomDialogBox dialogTitle={"Gateway name already in use"} dialogText={"This gateway name is already in use"} openDialog={required===2} handleCloseDialog={()=>setRequired(0)} handleConfirmDialog={()=>setRequired(0)} confirmText={"OK"} cancelText={"Cancel"} type={"Warning"}/>
                            <CustomCancelButton onClick={handleCloseAddForm} buttonText={'Cancel'} disabled={disableButtons!==0?true:false}></CustomCancelButton>
                            {/* <Button id={props.index} onClick={props.saveForm}>Save</Button> */}
                            <CustomButton id={gatewayinfo.id} onClick={handleSaveAddForm} buttonText={'Save'} width={'12px'} disabled={disableButtons!==0?true:false} />
                        </Box>
                    }
                </Box>
                <Box sx={{boxSizing:"border-box",padding:"8px",background:'var(--PrimaryBackground)',height:'calc(93%)',width:'100%',marginBottom:"0px",overflow:"auto"}}>
                    {/* <img src={LK_Loading} alt="loading..." style={{height:"10%" ,width:"auto"}} /> */}
                    {loading===0?
                        <>
                        {openForm===0?
                            <Box sx={{display:"flex",gap:'8px',flexWrap:'wrap',boxSizing:"border-box",height:'calc(100%)',width:'100%',overflow:"auto",alignContent:"flex-start"}} >
                                {ifsearching===0?
                                    <>
                                        {gatewayno.map((val,index) => (
                                            <>
                                                <GatewayCard index={index} gatewaylist={val}/>
                                            </>
                                        ))}
                                    </>
                                    :
                                    <>
                                        {searchList.length===0?
                                        <>
                                            <Typography className="config-heading" style={{ fontSize: '40px', fontWeight: 700, color: "var(--GreyBaseColor)", marginRight:"20px" ,justifySelf:"flex-end",justifyItems:"center",justifyContent:"center",justifyTracks:"center"}}>No Match Found</Typography>
                                        </>
                                        :
                                        <>
                                            {searchList.map((val,index) => (
                                                <>
                                                    <GatewayCard index={index} gatewaylist={val}/>
                                                </>
                                            ))}
                                        </>
                                        }
                                        
                                    </>
                                
                                }
                            </Box>
                            :
                            <Box sx={{display:"flex",gap:'8px',flexWrap:'wrap',height:'100%',boxSizing:"border-box"}} >
                                <GatewayForm /*formType={"Add"} openForm={openAddForm}*/ closeForm={handleCloseAddForm}  saveForm={handleSaveAddForm}  gatewayData={gatewayinfo} />
                            </Box>
                        }
                        </>
                        :
                        <Box sx={{gap:'8px',boxSizing:"border-box",height:'calc(100%)',width:'100%',overflow:"auto",alignContent:"center"}} >
                            <img src={LK_Loading} alt="loading..." style={{height:"15%" ,width:"auto",alignSelf:"center"}} />
                        </Box>
                    }
                </Box>
            </Box>
        </Box>
    )
}
